/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddAndSaveDriversToPool
// ====================================================

export interface AddAndSaveDriversToPool_addAndSaveDriversToPool {
  __typename: "AddAndSaveDriversToPoolResponse";
  errors: (string | null)[] | null;
}

export interface AddAndSaveDriversToPool {
  addAndSaveDriversToPool: AddAndSaveDriversToPool_addAndSaveDriversToPool | null;
}

export interface AddAndSaveDriversToPoolVariables {
  input?: AddAndSaveDriversToPoolRequest | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddAssetLoadNotes
// ====================================================

export interface AddAssetLoadNotes_addAssetLoadNotes {
  __typename: "AddAssetLoadNotesResponse";
  errors: (string | null)[] | null;
  loadNotesId: number | null;
}

export interface AddAssetLoadNotes {
  addAssetLoadNotes: AddAssetLoadNotes_addAssetLoadNotes | null;
}

export interface AddAssetLoadNotesVariables {
  input?: AddAssetLoadNotesInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddBoxes
// ====================================================

export interface AddBoxes_addBoxes {
  __typename: "AddBoxesResponse";
  errors: (string | null)[] | null;
}

export interface AddBoxes {
  addBoxes: AddBoxes_addBoxes | null;
}

export interface AddBoxesVariables {
  input?: AddBoxesInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddDriverLoadNotes
// ====================================================

export interface AddDriverLoadNotes_addDriverLoadNotes {
  __typename: "DriverLoadNotesAddResponse";
  errors: (string | null)[] | null;
  createdDriverLoadNotesId: number | null;
}

export interface AddDriverLoadNotes {
  addDriverLoadNotes: AddDriverLoadNotes_addDriverLoadNotes | null;
}

export interface AddDriverLoadNotesVariables {
  input?: AddDriverLoadNotesInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddEditJobLogs
// ====================================================

export interface AddEditJobLogs_addEditJobLogs {
  __typename: "AddEditJobLogsResponse";
  errors: (string | null)[] | null;
}

export interface AddEditJobLogs {
  addEditJobLogs: AddEditJobLogs_addEditJobLogs | null;
}

export interface AddEditJobLogsVariables {
  input?: AddEditJobLogsInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddEquipments
// ====================================================

export interface AddEquipments_addEquipments {
  __typename: "AddEquipmentsResponse";
  errors: (string | null)[] | null;
}

export interface AddEquipments {
  addEquipments: AddEquipments_addEquipments | null;
}

export interface AddEquipmentsVariables {
  input?: AddEquipmentsInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddFacilityToLofa
// ====================================================

export interface AddFacilityToLofa_addFacilityToLofa {
  __typename: "AddFacilityResponse";
  errors: (string | null)[] | null;
}

export interface AddFacilityToLofa {
  addFacilityToLofa: AddFacilityToLofa_addFacilityToLofa | null;
}

export interface AddFacilityToLofaVariables {
  input?: LofaScheduleEdit | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddJob
// ====================================================

export interface AddJob_addJob {
  __typename: "JobAddResponse";
  errors: (string | null)[] | null;
  createdJobId: number | null;
}

export interface AddJob {
  addJob: AddJob_addJob | null;
}

export interface AddJobVariables {
  input?: AddJobInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddJobNotes
// ====================================================

export interface AddJobNotes_addJobNotes {
  __typename: "JobNotesAddResponse";
  errors: (string | null)[] | null;
  createdJobNotesId: number | null;
}

export interface AddJobNotes {
  addJobNotes: AddJobNotes_addJobNotes | null;
}

export interface AddJobNotesVariables {
  input?: AddJobNotesInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddLoadNotes
// ====================================================

export interface AddLoadNotes_addLoadNotes {
  __typename: "AddLoadNotesResponse";
  errors: (string | null)[] | null;
  loadNotesId: number | null;
}

export interface AddLoadNotes {
  addLoadNotes: AddLoadNotes_addLoadNotes | null;
}

export interface AddLoadNotesVariables {
  input?: AddLoadNotesInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddProppant
// ====================================================

export interface AddProppant_addProppant {
  __typename: "ProppantAddResponse";
  errors: (string | null)[] | null;
  createdProppantId: number | null;
}

export interface AddProppant {
  addProppant: AddProppant_addProppant | null;
}

export interface AddProppantVariables {
  input?: ProppantAddRequest | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddStages
// ====================================================

export interface AddStages_addStages {
  __typename: "AddStagesResponse";
  errors: (string | null)[] | null;
}

export interface AddStages {
  addStages: AddStages_addStages | null;
}

export interface AddStagesVariables {
  input?: AddStagesInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AllocatePartial
// ====================================================

export interface AllocatePartial_allocatePartial {
  __typename: "AllocatePartialResponse";
  errors: (string | null)[] | null;
}

export interface AllocatePartial {
  allocatePartial: AllocatePartial_allocatePartial | null;
}

export interface AllocatePartialVariables {
  input?: AllocatePartialInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AllocatePartial
// ====================================================

export interface AllocateBox_allocateBox {
  __typename: "AllocateBoxResponse";
  errors: (string | null)[] | null;
}

export interface AllocateBox {
  allocatePartial: AllocateBox_allocateBox | null;
}

export interface AllocateBoxVariables {
  input?: AllocateBoxInput [] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AssignDriverToLoad
// ====================================================

export interface AssignDriverToLoad_assignDriverToLoad {
  __typename: "AssignDriverToLoadResponse";
  errors: (string | null)[] | null;
}

export interface AssignDriverToLoad {
  assignDriverToLoad: AssignDriverToLoad_assignDriverToLoad | null;
}

export interface AssignDriverToLoadVariables {
  driverId?: number | null;
  loadId?: number | null;
  isPrimaryDriver?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AssignDriverToLoadAndSaveLoad
// ====================================================

export interface AssignDriverToLoadAndSaveLoad_assignDriverToLoadAndSaveLoad {
  __typename: "CreateOrSaveLoadsResponse";
  errors: (string | null)[] | null;
  loadIds: (number | null)[] | null;
}

export interface AssignDriverToLoadAndSaveLoad {
  assignDriverToLoadAndSaveLoad: AssignDriverToLoadAndSaveLoad_assignDriverToLoadAndSaveLoad | null;
}

export interface AssignDriverToLoadAndSaveLoadVariables {
  input?: AssignDriverAndSaveLoadListEdit | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: configure
// ====================================================

export interface configure_configure {
  __typename: "configureResponses";
  errors: (string | null)[] | null;
}

export interface configure {
  configure: configure_configure | null;
}

export interface configureVariables {
  input?: ConfigureInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ConfigureInventory
// ====================================================

export interface ConfigureInventory_configureInventory {
  __typename: "ConfigureInventoryResponse";
  errors: (string | null)[] | null;
}

export interface ConfigureInventory {
  configureInventory: ConfigureInventory_configureInventory | null;
}

export interface ConfigureInventoryVariables {
  input?: ConfigureInventoryInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CountLoadsByJobSummeryIdsAndStatuses
// ====================================================

export interface CountLoadsByJobSummeryIdsAndStatuses_countLoadsByJobSummeryIdsAndStatuses {
  __typename: "Count";
  count: number;
}

export interface CountLoadsByJobSummeryIdsAndStatuses {
  countLoadsByJobSummeryIdsAndStatuses: CountLoadsByJobSummeryIdsAndStatuses_countLoadsByJobSummeryIdsAndStatuses;
}

export interface CountLoadsByJobSummeryIdsAndStatusesVariables {
  input?: CountLoadsInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateAssetLoad
// ====================================================

export interface CreateAssetLoad_createAssetLoad {
  __typename: "CreateAssetLoadResponse";
  errors: (string | null)[] | null;
  loadIds: (number | null)[] | null;
}

export interface CreateAssetLoad {
  createAssetLoad: CreateAssetLoad_createAssetLoad | null;
}

export interface CreateAssetLoadVariables {
  input?: CreateAssetLoadInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateLoads
// ====================================================

export interface CreateLoads_createLoads {
  __typename: "CreateOrSaveLoadsResponse";
  errors: (string | null)[] | null;
  loadIds: (number | null)[] | null;
}

export interface CreateLoads {
  createLoads: CreateLoads_createLoads | null;
}

export interface CreateLoadsVariables {
  input?: CreateLoadsInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteAssetLoads
// ====================================================

export interface DeleteAssetLoads_deleteAssetLoads {
  __typename: "DeleteAssetLoadsResponse";
  errors: (string | null)[] | null;
}

export interface DeleteAssetLoads {
  deleteAssetLoads: DeleteAssetLoads_deleteAssetLoads | null;
}

export interface DeleteAssetLoadsVariables {
  input?: DeleteAssetLoadsInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteCarrier
// ====================================================

export interface DeleteCarrier_deleteCarrier {
  __typename: "CarrierDeleteResponse";
  errors: (string | null)[] | null;
}

export interface DeleteCarrier {
  deleteCarrier: DeleteCarrier_deleteCarrier | null;
}

export interface DeleteCarrierVariables {
  input?: CarrierDeleteRequest | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteCrew
// ====================================================

export interface DeleteCrew_deleteCrew {
  __typename: "CrewDeleteResponse";
  errors: (string | null)[] | null;
}

export interface DeleteCrew {
  deleteCrew: DeleteCrew_deleteCrew | null;
}

export interface DeleteCrewVariables {
  input?: CrewDeleteRequest | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteCustomer
// ====================================================

export interface DeleteCustomer_deleteCustomer {
  __typename: "CustomerDeleteResponse";
  errors: (string | null)[] | null;
}

export interface DeleteCustomer {
  deleteCustomer: DeleteCustomer_deleteCustomer | null;
}

export interface DeleteCustomerVariables {
  input?: CustomerDeleteRequest | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteCustomerParent
// ====================================================

export interface DeleteCustomerParent_deleteCustomerParent {
  __typename: "CustomerParentDeleteResponse";
  errors: (string | null)[] | null;
}

export interface DeleteCustomerParent {
  deleteCustomerParent: DeleteCustomerParent_deleteCustomerParent | null;
}

export interface DeleteCustomerParentVariables {
  input?: CustomerParentDeleteRequest | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteDriver
// ====================================================

export interface DeleteDriver_deleteDriver {
  __typename: "DriverDeleteResponse";
  errors: (string | null)[] | null;
}

export interface DeleteDriver {
  deleteDriver: DeleteDriver_deleteDriver | null;
}

export interface DeleteDriverVariables {
  input?: DriverDeleteRequest | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteDriverLoadNotes
// ====================================================

export interface DeleteDriverLoadNotes_deleteDriverLoadNotes {
  __typename: "DeleteDriverLoadNotesResponse";
  errors: (string | null)[] | null;
}

export interface DeleteDriverLoadNotes {
  deleteDriverLoadNotes: DeleteDriverLoadNotes_deleteDriverLoadNotes | null;
}

export interface DeleteDriverLoadNotesVariables {
  input?: DeleteDriverLoadNotes | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteDriverLoadStatus
// ====================================================

export interface DeleteDriverLoadStatus_deleteDriverLoadStatus {
  __typename: "DriverLoadStatusDeleteResponse";
  errors: (string | null)[] | null;
}

export interface DeleteDriverLoadStatus {
  deleteDriverLoadStatus: DeleteDriverLoadStatus_deleteDriverLoadStatus | null;
}

export interface DeleteDriverLoadStatusVariables {
  input?: DriverLoadStatusDeleteRequest | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteJobImage
// ====================================================

export interface DeleteJobImage_deleteJobImage {
  __typename: "JobImageDeleteResponse";
  errors: (string | null)[] | null;
}

export interface DeleteJobImage {
  deleteJobImage: DeleteJobImage_deleteJobImage | null;
}

export interface DeleteJobImageVariables {
  input?: DeleteJobImageRequest | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteJobLog
// ====================================================

export interface DeleteJobLog_deleteJobLog {
  __typename: "DeleteJobLogResponse";
  errors: (string | null)[] | null;
}

export interface DeleteJobLog {
  deleteJobLog: DeleteJobLog_deleteJobLog | null;
}

export interface DeleteJobLogVariables {
  input?: DeleteJobLogInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteLoads
// ====================================================

export interface DeleteLoads_deleteLoads {
  __typename: "DeleteLoadsResponse";
  errors: (string | null)[] | null;
}

export interface DeleteLoads {
  deleteLoads: DeleteLoads_deleteLoads | null;
}

export interface DeleteLoadsVariables {
  input?: DeleteLoadsInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteLofa
// ====================================================

export interface DeleteLofa_deleteLofa {
  __typename: "LofaDeleteResponse";
  errors: (string | null)[] | null;
}

export interface DeleteLofa {
  deleteLofa: DeleteLofa_deleteLofa | null;
}

export interface DeleteLofaVariables {
  input?: LofaDeleteRequest | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteProppant
// ====================================================

export interface DeleteProppant_deleteProppant {
  __typename: "ProppantDeleteResponse";
  errors: (string | null)[] | null;
}

export interface DeleteProppant {
  deleteProppant: DeleteProppant_deleteProppant | null;
}

export interface DeleteProppantVariables {
  input?: ProppantDeleteRequest | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteVosUploadImage
// ====================================================

export interface DeleteVosUploadImage_deleteVosUploadImage {
  __typename: "VosUploadDeleteResponse";
  errors: (string | null)[] | null;
}

export interface DeleteVosUploadImage {
  deleteVosUploadImage: DeleteVosUploadImage_deleteVosUploadImage | null;
}

export interface DeleteVosUploadImageVariables {
  input?: DeleteVosUploadRequest | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteYard
// ====================================================

export interface DeleteYard_deleteYard {
  __typename: "DeleteYardResponse";
  errors: (string | null)[] | null;
}

export interface DeleteYard {
  deleteYard: DeleteYard_deleteYard | null;
}

export interface DeleteYardVariables {
  input?: DeleteYardInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DisableJob
// ====================================================

export interface DisableJob_disableJob {
  __typename: "EditResponse";
  errors: (string | null)[] | null;
}

export interface DisableJob {
  disableJob: DisableJob_disableJob | null;
}

export interface DisableJobVariables {
  input?: DisableJobInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: Dnuoperate
// ====================================================

export interface Dnuoperate_dnuoperate {
  __typename: "DnuOperateResponse";
  errors: (string | null)[] | null;
}

export interface Dnuoperate {
  dnuoperate: Dnuoperate_dnuoperate | null;
}

export interface DnuoperateVariables {
  input?: DnuOperateInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SpillBox
// ====================================================

export interface SpillBox_spillBox {
  __typename: "SpillBoxResponse";
  errors: (string | null)[] | null;
}

export interface SpillBox {
  spillBox: SpillBox_spillBox | null;
}

export interface SpillBoxVariables {
  input?: SpillBoxInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EditAssetLoad
// ====================================================

export interface EditAssetLoad_editAssetLoad {
  __typename: "EditAssetLoadResponse";
  errors: (string | null)[] | null;
}

export interface EditAssetLoad {
  editAssetLoad: EditAssetLoad_editAssetLoad | null;
}

export interface EditAssetLoadVariables {
  input?: EditAssetLoadInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EditAssetLoadNotes
// ====================================================

export interface EditAssetLoadNotes_editAssetLoadNotes {
  __typename: "EditResponse";
  errors: (string | null)[] | null;
}

export interface EditAssetLoadNotes {
  editAssetLoadNotes: EditAssetLoadNotes_editAssetLoadNotes | null;
}

export interface EditAssetLoadNotesVariables {
  input?: AssetLoadNotesEdit | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EditAssetLoadProgress
// ====================================================

export interface EditAssetLoadProgress_editAssetLoadProgress {
  __typename: "EditAssetLoadProgressResponse";
  errors: (string | null)[] | null;
}

export interface EditAssetLoadProgress {
  editAssetLoadProgress: EditAssetLoadProgress_editAssetLoadProgress | null;
}

export interface EditAssetLoadProgressVariables {
  input?: EditAssetLoadProgressInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EditBox
// ====================================================

export interface EditBox_editBox {
  __typename: "EditBoxResponse";
  errors: (string | null)[] | null;
}

export interface EditBox {
  editBox: EditBox_editBox | null;
}

export interface EditBoxVariables {
  input?: EditBoxInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EditDriverLoadNotes
// ====================================================

export interface EditDriverLoadNotes_editDriverLoadNotes {
  __typename: "EditDriverLoadNotesResponse";
  errors: (string | null)[] | null;
}

export interface EditDriverLoadNotes {
  editDriverLoadNotes: EditDriverLoadNotes_editDriverLoadNotes | null;
}

export interface EditDriverLoadNotesVariables {
  input?: DriverLoadNotesEdit | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EditJobNotes
// ====================================================

export interface EditJobNotes_editJobNotes {
  __typename: "EditResponse";
  errors: (string | null)[] | null;
}

export interface EditJobNotes {
  editJobNotes: EditJobNotes_editJobNotes | null;
}

export interface EditJobNotesVariables {
  input?: JobNotesEdit | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EditLeapFrog
// ====================================================

export interface EditLeapFrog_editLeapFrog {
  __typename: "EditLeapFrogResponse";
  errors: (string | null)[] | null;
}

export interface EditLeapFrog {
  editLeapFrog: EditLeapFrog_editLeapFrog | null;
}

export interface EditLeapFrogVariables {
  input?: EditLeapFrogInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EditLoadNotes
// ====================================================

export interface EditLoadNotes_editLoadNotes {
  __typename: "EditResponse";
  errors: (string | null)[] | null;
}

export interface EditLoadNotes {
  editLoadNotes: EditLoadNotes_editLoadNotes | null;
}

export interface EditLoadNotesVariables {
  input?: LoadNotesEdit | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EditPermissionsToRole
// ====================================================

export interface EditPermissionsToRole_editPermissionsToRole {
  __typename: "EditPermissionsToRoleResponse";
  errors: (string | null)[] | null;
}

export interface EditPermissionsToRole {
  editPermissionsToRole: EditPermissionsToRole_editPermissionsToRole | null;
}

export interface EditPermissionsToRoleVariables {
  input?: (EditPermissionsToRoleInput | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EditProppant
// ====================================================

export interface EditProppant_editProppant {
  __typename: "ProppantEditResponse";
  errors: (string | null)[] | null;
}

export interface EditProppant {
  editProppant: EditProppant_editProppant | null;
}

export interface EditProppantVariables {
  input?: ProppantEditRequest | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EditStages
// ====================================================

export interface EditStages_editStages {
  __typename: "EditStagesResponse";
  errors: (string | null)[] | null;
}

export interface EditStages {
  editStages: EditStages_editStages | null;
}

export interface EditStagesVariables {
  input?: EditStagesInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EditStageSheet
// ====================================================

export interface EditStageSheet_editStageSheet {
  __typename: "EditStageSheetResponse";
  errors: (string | null)[] | null;
}

export interface EditStageSheet {
  editStageSheet: EditStageSheet_editStageSheet | null;
}

export interface EditStageSheetVariables {
  input?: EditStageSheetInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EndStages
// ====================================================

export interface EndStages_endStages {
  __typename: "endStagesResponses";
  errors: (string | null)[] | null;
}

export interface EndStages {
  endStages: EndStages_endStages | null;
}

export interface EndStagesVariables {
  input?: EndStagesInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: MarkAllAsRead
// ====================================================

export interface MarkAllAsRead_markAllAsRead {
  __typename: "MessageUpdateResponse";
  errors: (string | null)[] | null;
}

export interface MarkAllAsRead {
  markAllAsRead: MarkAllAsRead_markAllAsRead | null;
}

export interface MarkAllAsReadVariables {
  input?: MarkAllReadInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: MarkAllConversationAsRead
// ====================================================

export interface MarkAllConversationAsRead_markAllConversationAsRead {
  __typename: "MessageUpdateResponse";
  errors: (string | null)[] | null;
}

export interface MarkAllConversationAsRead {
  markAllConversationAsRead: MarkAllConversationAsRead_markAllConversationAsRead | null;
}

export interface MarkAllConversationAsReadVariables {
  input?: MarkAllConversationReadInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: MoveBoxes
// ====================================================

export interface MoveBoxes_moveBoxes {
  __typename: "MoveBoxesResponse";
  errors: (string | null)[] | null;
}

export interface MoveBoxes {
  moveBoxes: MoveBoxes_moveBoxes | null;
}

export interface MoveBoxesVariables {
  input?: MoveBoxesInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RevertBoxes
// ====================================================

export interface RevertBoxes_revertBoxes {
  __typename: "RevertBoxesResponse";
  errors: (string | null)[] | null;
}

export interface RevertBoxes {
  revertBoxes: RevertBoxes_revertBoxes | null;
}

export interface RevertBoxesVariables {
  input?: RevertBoxesInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: PauseStages
// ====================================================

export interface PauseStages_pauseStages {
  __typename: "pauseStagesResponses";
  errors: (string | null)[] | null;
}

export interface PauseStages {
  pauseStages: PauseStages_pauseStages | null;
}

export interface PauseStagesVariables {
  input?: PauseStagesInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddNewRole
// ====================================================

export interface AddNewRole_addNewRole {
  __typename: "AddNewRoleResponse";
  errors: (string | null)[] | null;
}

export interface AddNewRole {
  addNewRole: AddNewRole_addNewRole | null;
}

export interface AddNewRoleVariables {
  input?: AddNewRoleInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveBox
// ====================================================

export interface RemoveBox_removeBox {
  __typename: "RemoveBoxResponse";
  errors: (string | null)[] | null;
}

export interface RemoveBox {
  removeBox: RemoveBox_removeBox | null;
}

export interface RemoveBoxVariables {
  input?: RemoveBoxInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveImageFromALoad
// ====================================================

export interface RemoveImageFromALoad_removeImageFromALoad {
  __typename: "LoadEditResponse";
  errors: (string | null)[] | null;
}

export interface RemoveImageFromALoad {
  removeImageFromALoad: RemoveImageFromALoad_removeImageFromALoad | null;
}

export interface RemoveImageFromALoadVariables {
  input?: RemoveImageFromALoadInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ReplaceImageForALoad
// ====================================================

export interface ReplaceImageForALoad_replaceImageForALoad {
  __typename: "LoadEditResponse";
  errors: (string | null)[] | null;
}

export interface ReplaceImageForALoad {
  replaceImageForALoad: ReplaceImageForALoad_replaceImageForALoad | null;
}

export interface ReplaceImageForALoadVariables {
  input?: ReplaceImageForALoadInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ResolveAllDriverLoadNotes
// ====================================================

export interface ResolveAllDriverLoadNotes_resolveAllDriverLoadNotes {
  __typename: "ResolveLoadNotesResponse";
  errors: (string | null)[] | null;
}

export interface ResolveAllDriverLoadNotes {
  resolveAllDriverLoadNotes: ResolveAllDriverLoadNotes_resolveAllDriverLoadNotes | null;
}

export interface ResolveAllDriverLoadNotesVariables {
  input?: ResolveAllDriverLoadNotesInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ResolveDriverLoadNote
// ====================================================

export interface ResolveDriverLoadNote_resolveDriverLoadNote {
  __typename: "ResolveLoadNotesResponse";
  errors: (string | null)[] | null;
}

export interface ResolveDriverLoadNote {
  resolveDriverLoadNote: ResolveDriverLoadNote_resolveDriverLoadNote | null;
}

export interface ResolveDriverLoadNoteVariables {
  input?: ResolveDriverLoadNoteInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ResumeStages
// ====================================================

export interface ResumeStages_resumeStages {
  __typename: "resumeStagesResponses";
  errors: (string | null)[] | null;
}

export interface ResumeStages {
  resumeStages: ResumeStages_resumeStages | null;
}

export interface ResumeStagesVariables {
  input?: ResumeStagesInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RevertStages
// ====================================================

export interface RevertStages_revertStages {
  __typename: "RevertStagesResponse";
  errors: (string | null)[] | null;
}

export interface RevertStages {
  revertStages: RevertStages_revertStages | null;
}

export interface RevertStagesVariables {
  input?: RevertStagesInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RevertStageSheet
// ====================================================

export interface RevertStageSheet_revertStageSheet {
  __typename: "RevertStageSheetResponse";
  errors: (string | null)[] | null;
}

export interface RevertStageSheet {
  revertStageSheet: RevertStageSheet_revertStageSheet | null;
}

export interface RevertStageSheetVariables {
  input?: RevertStageSheetInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RunOrder
// ====================================================

export interface RunOrder_runOrder {
  __typename: "RunOrderResponse";
  errors: (string | null)[] | null;
}

export interface RunOrder {
  runOrder: RunOrder_runOrder | null;
}

export interface RunOrderVariables {
  input?: RunOrderInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SaveCarrier
// ====================================================

export interface SaveCarrier_saveCarrier {
  __typename: "SaveCarrierResponse";
  errors: (string | null)[] | null;
}

export interface SaveCarrier {
  saveCarrier: SaveCarrier_saveCarrier | null;
}

export interface SaveCarrierVariables {
  input?: SaveCarrierInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SaveCrew
// ====================================================

export interface SaveCrew_saveCrew {
  __typename: "SaveCrewResponse";
  errors: (string | null)[] | null;
}

export interface SaveCrew {
  saveCrew: SaveCrew_saveCrew | null;
}

export interface SaveCrewVariables {
  input?: SaveCrewInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SaveCustomer
// ====================================================

export interface SaveCustomer_saveCustomer {
  __typename: "SaveCustomerResponse";
  errors: (string | null)[] | null;
}

export interface SaveCustomer {
  saveCustomer: SaveCustomer_saveCustomer | null;
}

export interface SaveCustomerVariables {
  input?: SaveCustomerInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SaveCustomerParent
// ====================================================

export interface SaveCustomerParent_saveCustomerParent {
  __typename: "SaveCustomerParentResponse";
  errors: (string | null)[] | null;
}

export interface SaveCustomerParent {
  saveCustomerParent: SaveCustomerParent_saveCustomerParent | null;
}

export interface SaveCustomerParentVariables {
  input?: SaveCustomerParentInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SaveDriver
// ====================================================

export interface SaveDriver_saveDriver {
  __typename: "SaveDriverResponse";
  errors: (string | null)[] | null;
}

export interface SaveDriver {
  saveDriver: SaveDriver_saveDriver | null;
}

export interface SaveDriverVariables {
  input?: SaveDriverInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SaveLofa
// ====================================================

export interface SaveLofa_saveLofa {
  __typename: "SaveLofaResponse";
  errors: (string | null)[] | null;
}

export interface SaveLofa {
  saveLofa: SaveLofa_saveLofa | null;
}

export interface SaveLofaVariables {
  input?: SaveLofaInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SaveTonnage
// ====================================================

export interface SaveTonnage_saveTonnage {
  __typename: "SaveTonnageResponse";
  errors: (string | null)[] | null;
}

export interface SaveTonnage {
  saveTonnage: SaveTonnage_saveTonnage | null;
}

export interface SaveTonnageVariables {
  input?: SaveTonnageInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SaveUser
// ====================================================

export interface SaveUser_saveUser {
  __typename: "SaveUserResponse";
  errors: (string | null)[] | null;
}

export interface SaveUser {
  saveUser: SaveUser_saveUser | null;
}

export interface SaveUserVariables {
  input?: SaveUserInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SaveYard
// ====================================================

export interface SaveYard_saveYard {
  __typename: "SaveYardResponse";
  errors: (string | null)[] | null;
}

export interface SaveYard {
  saveYard: SaveYard_saveYard | null;
}

export interface SaveYardVariables {
  input?: SaveYardInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SendEmail
// ====================================================

export interface SendEmail_sendEmail {
  __typename: "SendEmailResponse";
  errors: (string | null)[] | null;
}

export interface SendEmail {
  sendEmail: SendEmail_sendEmail | null;
}

export interface SendEmailVariables {
  input?: SendEmailInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SendMessageToConversation
// ====================================================

export interface SendMessageToConversation_sendMessageToConversation {
  __typename: "SendMessageToConversationResponse";
  conversationId: string | null;
  messageId: number | null;
  messageUserId: number | null;
}

export interface SendMessageToConversation {
  sendMessageToConversation: SendMessageToConversation_sendMessageToConversation | null;
}

export interface SendMessageToConversationVariables {
  input?: SendMessageToConversationInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: StartStages
// ====================================================

export interface StartStages_startStages {
  __typename: "startStagesRespone";
  errors: (string | null)[] | null;
}

export interface StartStages {
  startStages: StartStages_startStages | null;
}

export interface StartStagesVariables {
  input?: StartStagesInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: StopJobLog
// ====================================================

export interface StopJobLog_stopJobLog {
  __typename: "StopJobLogResponse";
  errors: (string | null)[] | null;
}

export interface StopJobLog {
  stopJobLog: StopJobLog_stopJobLog | null;
}

export interface StopJobLogVariables {
  input?: StopJobLogInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateActiveForJobSummary
// ====================================================

export interface UpdateActiveForJobSummary_updateActiveForJobSummary {
  __typename: "UpdateActiveForJobSummaryResponse";
  message: string | null;
}

export interface UpdateActiveForJobSummary {
  updateActiveForJobSummary: UpdateActiveForJobSummary_updateActiveForJobSummary | null;
}

export interface UpdateActiveForJobSummaryVariables {
  input?: UpdateActiveForJobSummaryInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateAssetPlans
// ====================================================

export interface UpdateAssetPlans_updateAssetPlans {
  __typename: "UpdateAssetPlansResponse";
  errors: (string | null)[] | null;
}

export interface UpdateAssetPlans {
  updateAssetPlans: UpdateAssetPlans_updateAssetPlans | null;
}

export interface UpdateAssetPlansVariables {
  input?: UpdateAssetPlansInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateBox
// ====================================================

export interface UpdateBox_updateBox {
  __typename: "UpdateBoxResponse";
  errors: (string | null)[] | null;
}

export interface UpdateBox {
  updateBox: UpdateBox_updateBox | null;
}

export interface UpdateBoxVariables {
  input?: UpdateBoxInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateBoxInLoad
// ====================================================

export interface UpdateBoxInLoad_updateBoxInLoad {
  __typename: "UpdateBoxInLoadResponse";
  errors: (string | null)[] | null;
}

export interface UpdateBoxInLoad {
  updateBoxInLoad: UpdateBoxInLoad_updateBoxInLoad | null;
}

export interface UpdateBoxInLoadVariables {
  input?: UpdateBoxInLoadInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateBoxWeight
// ====================================================

export interface UpdateBoxWeight_updateBoxWeight {
  __typename: "UpdateBoxWeightResponses";
  errors: (string | null)[] | null;
}

export interface UpdateBoxWeight {
  updateBoxWeight: UpdateBoxWeight_updateBoxWeight | null;
}

export interface UpdateBoxWeightVariables {
  input?: UpdateBoxWeightInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateInventoryWeight
// ====================================================

export interface UpdateInventoryWeight_updateInventoryWeight {
  __typename: "UpdateInventoryWeightResponses";
  errors: (string | null)[] | null;
}

export interface UpdateInventoryWeight {
  updateInventoryWeight: UpdateInventoryWeight_updateInventoryWeight | null;
}

export interface UpdateInventoryWeightVariables {
  input?: UpdateInventoryWeightInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateJobProfile
// ====================================================

export interface UpdateJobProfile_updateJobProfile {
  __typename: "EditResponse";
  errors: (string | null)[] | null;
}

export interface UpdateJobProfile {
  updateJobProfile: UpdateJobProfile_updateJobProfile | null;
}

export interface UpdateJobProfileVariables {
  input?: JobProfileEdit | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateLastMessageAsRead
// ====================================================

export interface UpdateLastMessageAsRead_updateLastMessageAsRead {
  __typename: "MessageUpdateResponse";
  errors: (string | null)[] | null;
}

export interface UpdateLastMessageAsRead {
  updateLastMessageAsRead: UpdateLastMessageAsRead_updateLastMessageAsRead | null;
}

export interface UpdateLastMessageAsReadVariables {
  input?: MessageStatusInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateLoadAccessorials
// ====================================================

export interface UpdateLoadAccessorials_updateLoadAccessorials {
  __typename: "LoadEditResponse";
  errors: (string | null)[] | null;
}

export interface UpdateLoadAccessorials {
  updateLoadAccessorials: UpdateLoadAccessorials_updateLoadAccessorials | null;
}

export interface UpdateLoadAccessorialsVariables {
  input?: LoadAccessorialsEdit | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateLoadDetail
// ====================================================

export interface UpdateLoadDetail_updateLoadDetail {
  __typename: "LoadEditResponse";
  errors: (string | null)[] | null;
}

export interface UpdateLoadDetail {
  updateLoadDetail: UpdateLoadDetail_updateLoadDetail | null;
}

export interface UpdateLoadDetailVariables {
  input?: LoadDetailEdit | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateLoadFieldOpDetail
// ====================================================

export interface UpdateLoadFieldOpDetail_updateLoadFieldOpDetail {
  __typename: "LoadEditResponse";
  errors: (string | null)[] | null;
}

export interface UpdateLoadFieldOpDetail {
  updateLoadFieldOpDetail: UpdateLoadFieldOpDetail_updateLoadFieldOpDetail | null;
}

export interface UpdateLoadFieldOpDetailVariables {
  input?: LoadDetailFieldOpEdit | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateLoadProgress
// ====================================================

export interface UpdateLoadProgress_updateLoadProgress {
  __typename: "LoadEditResponse";
  errors: (string | null)[] | null;
}

export interface UpdateLoadProgress {
  updateLoadProgress: UpdateLoadProgress_updateLoadProgress | null;
}

export interface UpdateLoadProgressVariables {
  input?: LoadProgressEdit | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateLoadStatus
// ====================================================

export interface UpdateLoadStatus_updateLoadStatus {
  __typename: "LoadEditResponse";
  errors: (string | null)[] | null;
}

export interface UpdateLoadStatus {
  updateLoadStatus: UpdateLoadStatus_updateLoadStatus | null;
}

export interface UpdateLoadStatusVariables {
  input?: LoadStatusEdit | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateLoadStatusBackwards
// ====================================================

export interface UpdateLoadStatusBackwards_updateLoadStatusBackwards {
  __typename: "LoadEditResponse";
  errors: (string | null)[] | null;
}

export interface UpdateLoadStatusBackwards {
  updateLoadStatusBackwards: UpdateLoadStatusBackwards_updateLoadStatusBackwards | null;
}

export interface UpdateLoadStatusBackwardsVariables {
  input?: LoadStatusEdit | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateLofaScheduleInfo
// ====================================================

export interface UpdateLofaScheduleInfo_updateLofaScheduleInfo {
  __typename: "EditResponse";
  errors: (string | null)[] | null;
}

export interface UpdateLofaScheduleInfo {
  updateLofaScheduleInfo: UpdateLofaScheduleInfo_updateLofaScheduleInfo | null;
}

export interface UpdateLofaScheduleInfoVariables {
  input?: LofaScheduleEdit | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdatePumpScheduleInfo
// ====================================================

export interface UpdatePumpScheduleInfo_updatePumpScheduleInfo {
  __typename: "EditResponse";
  errors: (string | null)[] | null;
}

export interface UpdatePumpScheduleInfo {
  updatePumpScheduleInfo: UpdatePumpScheduleInfo_updatePumpScheduleInfo | null;
}

export interface UpdatePumpScheduleInfoVariables {
  input?: PumpScheduleEdit | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateSplitLoad
// ====================================================

export interface UpdateSplitLoad_updateSplitLoad {
  __typename: "LoadEditResponse";
  errors: (string | null)[] | null;
}

export interface UpdateSplitLoad {
  updateSplitLoad: UpdateSplitLoad_updateSplitLoad | null;
}

export interface UpdateSplitLoadVariables {
  loadId?: number | null;
  isSplit?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UploadImageToJob
// ====================================================

export interface UploadImageToJob_uploadImageToJob {
  __typename: "EditResponse";
  errors: (string | null)[] | null;
}

export interface UploadImageToJob {
  uploadImageToJob: UploadImageToJob_uploadImageToJob | null;
}

export interface UploadImageToJobVariables {
  input?: UploadImageToJobInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UploadImageToLoad
// ====================================================

export interface UploadImageToLoad_uploadImageToLoad {
  __typename: "LoadEditResponse";
  errors: (string | null)[] | null;
}

export interface UploadImageToLoad {
  uploadImageToLoad: UploadImageToLoad_uploadImageToLoad | null;
}

export interface UploadImageToLoadVariables {
  input?: UploadImageToLoadInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: validateSBXBox
// ====================================================

export interface ValidateSBXBox_validateSBXBox {
  __typename: "ValidateSBXBoxResponse";
  isBoxValid: boolean | null;
  isReturnBox2Valid: boolean | null;
  isReturnBox1Valid: boolean | null;
  errorMessage: string | null;
}

export interface ValidateSBXBox {
  validateSBXBox: ValidateSBXBox_validateSBXBox | null;
}

export interface ValidateSBXBoxInput {
  boxId?: number | null;
  boxNumber?: string | null;
  isBox?: boolean | null;
  isReturnBox?: boolean | null;
  returnBoxId1?: number | null;
  returnBoxName1?: string | null;
  returnBoxId2?: number | null;
  returnBoxName2?: string | null;
}

export interface ValidateSBXBoxVariables {
  input?: ValidateSBXBoxInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ValidateInventoryBox
// ====================================================

export interface ValidateInventoryBox_validateInventoryBox {
  __typename: "ValidateInventoryBoxResponse";
  errors: (string | null)[] | null;
}

export interface ValidateInventoryBox {
  validateInventoryBox: ValidateInventoryBox_validateInventoryBox | null;
}

export interface ValidateInventoryBoxVariables {
  input?: ValidateInventoryBoxInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: VosUploadImage
// ====================================================

export interface VosUploadImage_vosUploadImage {
  __typename: "EditResponse";
  errors: (string | null)[] | null;
}

export interface VosUploadImage {
  vosUploadImage: VosUploadImage_vosUploadImage | null;
}

export interface VosUploadImageVariables {
  input?: VosUploadImageInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CountLoadsByJobProppant
// ====================================================

export interface CountLoadsByJobProppant_countLoadsByJobProppant {
  __typename: "Count";
  count: number;
}

export interface CountLoadsByJobProppant {
  countLoadsByJobProppant: CountLoadsByJobProppant_countLoadsByJobProppant;
}

export interface CountLoadsByJobProppantVariables {
  input?: CountLoadsByJobProppantInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CountLoadsByJobSummaryIdsAndStatus
// ====================================================

export interface CountLoadsByJobSummaryIdsAndStatus_countLoadsByJobSummaryIdsAndStatus {
  __typename: "Count";
  count: number;
}

export interface CountLoadsByJobSummaryIdsAndStatus {
  countLoadsByJobSummaryIdsAndStatus: CountLoadsByJobSummaryIdsAndStatus_countLoadsByJobSummaryIdsAndStatus;
}

export interface CountLoadsByJobSummaryIdsAndStatusVariables {
  input?: CountLoadsInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CountLoadsByJobWellhead
// ====================================================

export interface CountLoadsByJobWellhead_countLoadsByJobWellhead {
  __typename: "Count";
  count: number;
}

export interface CountLoadsByJobWellhead {
  countLoadsByJobWellhead: CountLoadsByJobWellhead_countLoadsByJobWellhead;
}

export interface CountLoadsByJobWellheadVariables {
  input?: CountLoadsByJobWellheadInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ExportDriverMessagesByDriverId
// ====================================================

export interface ExportDriverMessagesByDriverId_exportDriverMessagesByDriverId {
  __typename: "ExportResult";
  csvDownloadUrl: string | null;
}

export interface ExportDriverMessagesByDriverId {
  exportDriverMessagesByDriverId: ExportDriverMessagesByDriverId_exportDriverMessagesByDriverId | null;
}

export interface ExportDriverMessagesByDriverIdVariables {
  input?: ExportDriverMessageQueryInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAccessorialForLoadDetail
// ====================================================

export interface GetAccessorialForLoadDetail_getAccessorialForLoadDetail {
  __typename: "ViewAccessorial";
  accessorialId: number;
  accessorialName: string | null;
  isDeleted: boolean | null;
  extSystemName: string | null;
  extSystemReference: string | null;
}

export interface GetAccessorialForLoadDetail {
  getAccessorialForLoadDetail: (GetAccessorialForLoadDetail_getAccessorialForLoadDetail | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetActivitySymmary
// ====================================================

export interface GetActivitySymmary_getActivitySummary {
  __typename: "ActivitySummaryResponse";
  proppantName: string | null;
  lofaName: string | null;
  wellName: string | null;
  created: number | null;
  accepted: number | null;
  assigned: number | null;
  loading: number | null;
  loaded: number | null;
  unloading: number | null;
  totalActiveTrucks: number | null;
  proppantId: number | null;
  lofaId: number | null;
  regionId: number | null;
  sandPO: string | null;
  transportationPO: string | null;
}

export interface GetActivitySymmary {
  getActivitySummary: (GetActivitySymmary_getActivitySummary | null)[] | null;
}

export interface GetActivitySymmaryVariables {
  input?: ActivitySummaryInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllAccessorials
// ====================================================

export interface GetAllAccessorials_getAllAccessorials {
  __typename: "Accessorial";
  accessorialId: number;
  accessorialName: string | null;
  isDeleted: boolean | null;
}

export interface GetAllAccessorials {
  getAllAccessorials: (GetAllAccessorials_getAllAccessorials | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllAssetLoadStatusTypes
// ====================================================

export interface GetAllAssetLoadStatusTypes_getAllAssetLoadStatusTypes {
  __typename: "FilterObjectModel_LoadStatusTypes";
  id: number;
  name: string;
}

export interface GetAllAssetLoadStatusTypes {
  getAllAssetLoadStatusTypes: (GetAllAssetLoadStatusTypes_getAllAssetLoadStatusTypes | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllAssetLoadTypes
// ====================================================

export interface GetAllAssetLoadTypes_getAllAssetLoadTypes {
  __typename: "FilterObjectModel_AssetLoadTypes";
  id: number;
  name: string;
}

export interface GetAllAssetLoadTypes {
  getAllAssetLoadTypes: (GetAllAssetLoadTypes_getAllAssetLoadTypes | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllCarriers
// ====================================================

export interface GetAllCarriers_getAllCarriers {
  __typename: "CarrierMasterData";
  id: number | null;
  companyName: string | null;
  type: string | null;
  stateId: number | null;
  isActive: boolean | null;
  extSystemIdentifier: string | null;
  extSystemIdentifier2: string | null;
  extSystemName: string | null;
  activeInactiveDate: string | null;
  activeInactiveUser: string | null;
  name: string | null;
  addressLine1: string | null;
  addressLine2: string | null;
  notes: string | null;
  city: string | null;
  zip: string | null;
  phoneNumber: string | null;
  email: string | null;
  isCompliant: boolean | null;
  acronym: string | null;
}

export interface GetAllCarriers {
  getAllCarriers: (GetAllCarriers_getAllCarriers | null)[] | null;
}

export interface GetAllCarriersVariables {
  input?: CarrierMasterDataInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllCarriersFilter
// ====================================================

export interface GetAllCarriersFilter_getAllCarriersFilter {
  __typename: "FilterObjectModel_Carrier";
  id: number;
  name: string;
}

export interface GetAllCarriersFilter {
  getAllCarriersFilter: (GetAllCarriersFilter_getAllCarriersFilter | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllChasisData
// ====================================================

export interface GetAllChasisData_getAllChasisData {
  __typename: "GetChasisData";
  id: number | null;
  sbsId: string | null;
  jdeId: string | null;
  oldSBSId: string | null;
  trailerType: string | null;
  serviceStatus: string | null;
  leasedTo: string | null;
}

export interface GetAllChasisData {
  getAllChasisData: (GetAllChasisData_getAllChasisData | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllCrewFiltered
// ====================================================

export interface GetAllCrewFiltered_getAllCrewFiltered {
  __typename: "Crew";
  id: number;
  crewNumber: string | null;
  customerId: number;
  customerName: string | null;
  isDeleted: boolean | null;
}

export interface GetAllCrewFiltered {
  getAllCrewFiltered: (GetAllCrewFiltered_getAllCrewFiltered | null)[] | null;
}

export interface GetAllCrewFilteredVariables {
  input?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllCrews
// ====================================================

export interface GetAllCrews_getAllCrews {
  __typename: "Crew";
  id: number;
  crewNumber: string | null;
  customerId: number;
  isDeleted: boolean | null;
}

export interface GetAllCrews {
  getAllCrews: (GetAllCrews_getAllCrews | null)[] | null;
}

export interface GetAllCrewsVariables {
  customerId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllCustomerParents
// ====================================================

export interface GetAllCustomerParents_getAllCustomerParents {
  __typename: "CustomerParent";
  id: number | null;
  customerName: string | null;
  enabled: boolean | null;
  isDeleted: boolean | null;
  extSystemName: string | null;
  extSystemIdentifier: string | null;
}

export interface GetAllCustomerParents {
  getAllCustomerParents: (GetAllCustomerParents_getAllCustomerParents | null)[] | null;
}

export interface GetAllCustomerParentsVariables {
  input?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllCustomers
// ====================================================

export interface GetAllCustomers_getAllCustomers {
  __typename: "Customer";
  id: number | null;
  customerName: string | null;
  description: string | null;
  enabled: boolean | null;
  isDeleted: boolean | null;
  extSystemName: string | null;
  extSystemIdentifier: string | null;
  industryClassificationCode: string | null;
  customerParentId: number | null;
}

export interface GetAllCustomers {
  getAllCustomers: (GetAllCustomers_getAllCustomers | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllCustomersFiltered
// ====================================================

export interface GetAllCustomersFiltered_getAllCustomersFiltered {
  __typename: "Customer";
  id: number | null;
  customerName: string | null;
  description: string | null;
  enabled: boolean | null;
  isDeleted: boolean | null;
  extSystemName: string | null;
  extSystemIdentifier: string | null;
  industryClassificationCode: string | null;
  customerParentId: number | null;
}

export interface GetAllCustomersFiltered {
  getAllCustomersFiltered: (GetAllCustomersFiltered_getAllCustomersFiltered | null)[] | null;
}

export interface GetAllCustomersFilteredVariables {
  input?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllDriversByCarriers
// ====================================================

export interface GetAllDriversByCarriers_getAllDriversByCarriers {
  __typename: "FilterObjectModel_Driver";
  id: number;
  name: string;
}

export interface GetAllDriversByCarriers {
  getAllDriversByCarriers: (GetAllDriversByCarriers_getAllDriversByCarriers | null)[] | null;
}

export interface GetAllDriversByCarriersVariables {
  input?: CarrierListInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllDriversByMessage
// ====================================================

export interface GetAllDriversByMessage_getAllDriversByMessage_driverView {
  __typename: "DriversWithGroup";
  resultId: number | null;
  name: string | null;
  isShiftStarted: boolean | null;
  isAssigned: boolean | null;
  driverId: number | null;
  driverCompanyName: string | null;
  isRead: number | null;
  cellPhone: string | null;
  isWaitingOnLoad: boolean | null;
  isLastLoadRejected: number | null;
}

export interface GetAllDriversByMessage_getAllDriversByMessage {
  __typename: "DriverWithGroupAndCount";
  driverView: (GetAllDriversByMessage_getAllDriversByMessage_driverView | null)[] | null;
  totalCount: number | null;
}

export interface GetAllDriversByMessage {
  getAllDriversByMessage: GetAllDriversByMessage_getAllDriversByMessage | null;
}

export interface GetAllDriversByMessageVariables {
  input?: DriverMessageInput | null;
  offset?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllDrivers
// ====================================================

export interface GetAllDrivers_getAllDrivers {
  __typename: "DriverListItem";
  driverId: number;
  driverName: string;
  driverCompany: string | null;
  regionId: number;
  trainingStatus: number | null;
  checkInWithBellyDump: boolean | null;
  isAvailable: boolean | null;
}

export interface GetAllDrivers {
  getAllDrivers: (GetAllDrivers_getAllDrivers | null)[] | null;
}

export interface GetAllDriversVariables {
  regionId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllDriversByRegionIds
// ====================================================

export interface GetAllDriversByRegionIds_getAllDriversByRegionIds {
  __typename: "DriverByRegion";
  id: number | null;
  name: string | null;
  driverCompanyId: number | null;
}

export interface GetAllDriversByRegionIds {
  getAllDriversByRegionIds: (GetAllDriversByRegionIds_getAllDriversByRegionIds | null)[] | null;
}

export interface GetAllDriversByRegionIdsVariables {
  ids?: (number | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllDriversFilter
// ====================================================

export interface GetAllDriversFilter_getAllDriversFilter {
  __typename: "FilterObjectModel_Driver";
  id: number;
  name: string;
}

export interface GetAllDriversFilter {
  getAllDriversFilter: (GetAllDriversFilter_getAllDriversFilter | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllDriversMasterData
// ====================================================

export interface GetAllDriversMasterData_getAllDriversMasterData {
  __typename: "DriverMasterData";
  driverId: number;
  name: string;
  regionName: string | null;
  districtName: string | null;
  isActive: boolean | null;
  cellPhone: string | null;
  cdlNumber: string | null;
  activeInactiveDate: string | null;
  activeInactiveUser: string | null;
  companyName: string | null;
  kronosId: string | null;
  driverType: string | null;
  cdlExpiryDate: string | null;
  driverCompanyId: number | null;
  isAssigned: boolean | null;
  isManual: boolean | null;
  isAvailable: boolean | null;
  isShiftStarted: boolean | null;
  regionIds: string | null;
  districtIds: string | null;
  isLocked: boolean | null;
  extSystemIdentifier: string | null;
  extSystemName: string | null;
  inactiveReason: string | null;
  reactivationDate: string | null;
  loadId: string | null;
  status: string | null;
  driverPool: string | null;
  extSystemIdentifier3: string | null;
  trainingStatus: number | null;
  checkInWithBellyDump: boolean | null;
}

export interface GetAllDriversMasterData {
  getAllDriversMasterData: (GetAllDriversMasterData_getAllDriversMasterData | null)[] | null;
}

export interface GetAllDriversMasterDataVariables {
  input?: DriverListInput | null;
  offset?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllEpCompanies
// ====================================================

export interface GetAllEpCompanies_getAllEpCompanies {
  __typename: "EpCompany";
  id: number;
  companyName: string | null;
}

export interface GetAllEpCompanies {
  getAllEpCompanies: (GetAllEpCompanies_getAllEpCompanies | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllEquipmentTypes
// ====================================================

export interface GetAllEquipmentTypes_getAllEquipmentTypes {
  __typename: "FilterObjectModel_EquipmentTypes";
  id: number;
  name: string;
}

export interface GetAllEquipmentTypes {
  getAllEquipmentTypes: (GetAllEquipmentTypes_getAllEquipmentTypes | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllJobsFilter
// ====================================================

export interface GetAllJobsFilter_getAllJobsFilter {
  __typename: "FilterObjectModel_Job";
  id: number;
  name: string;
}

export interface GetAllJobsFilter {
  getAllJobsFilter: (GetAllJobsFilter_getAllJobsFilter | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllJobsWithFiltersAndSearch
// ====================================================

export interface GetAllJobsWithFiltersAndSearch_getAllJobsWithFiltersAndSearch {
  __typename: "JobSummary";
  jobId: string;
  jobName: string;
  jdeNumber: string;
  region: string;
  district: string;
  customerName: string;
  startDate: string;
  endDate: string;
  estimatedEndDate: string;
  status: Status;
}

export interface GetAllJobsWithFiltersAndSearch {
  getAllJobsWithFiltersAndSearch: (GetAllJobsWithFiltersAndSearch_getAllJobsWithFiltersAndSearch | null)[] | null;
}

export interface GetAllJobsWithFiltersAndSearchVariables {
  input?: GetAllJobsInput | null;
  offset?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllLocations
// ====================================================

export interface GetAllLocations_getAllLocations {
  __typename: "GetAllLocationsResponse";
  locationId: number | null;
  descrip: string | null;
  locationType: string | null;
}

export interface GetAllLocations {
  getAllLocations: (GetAllLocations_getAllLocations | null)[] | null;
}

export interface GetAllLocationsVariables {
  input?: GetAllLocationsInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllLofas
// ====================================================

export interface GetAllLofas_getAllLofas {
  __typename: "Lofa";
  lofaId: number | null;
  lofaName: string | null;
}

export interface GetAllLofas {
  getAllLofas: (GetAllLofas_getAllLofas | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllLofasByJob
// ====================================================

export interface GetAllLofasByJob_getAllLofasByJob {
  __typename: "Lofa";
  lofaId: number | null;
  lofaName: string | null;
}

export interface GetAllLofasByJob {
  getAllLofasByJob: (GetAllLofasByJob_getAllLofasByJob | null)[] | null;
}

export interface GetAllLofasByJobVariables {
  jobId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllLofasFiltered
// ====================================================

export interface GetAllLofasFiltered_getAllLofasFiltered_polygonCoordinates {
  __typename: "polygnCoordinates";
  lat: number | null;
  lng: number | null;
}

export interface GetAllLofasFiltered_getAllLofasFiltered {
  __typename: "LofaFiltered";
  id: number | null;
  lofaName: string | null;
  addressStreet: string | null;
  city: string | null;
  zip: string | null;
  phoneNumber: string | null;
  jdeNumber: string | null;
  description: string | null;
  stateId: number | null;
  utm: string | null;
  latitude: number | null;
  longitude: number | null;
  entryKioskLatitude: number | null;
  entryKioskLongitude: number | null;
  directions: string | null;
  geoFenceType: string | null;
  geoFenceRadius: number | null;
  polygonCoordinates: (GetAllLofasFiltered_getAllLofasFiltered_polygonCoordinates | null)[] | null;
  entryKioskPolygonCoordinates: (GetAllLofasFiltered_getAllLofasFiltered_polygonCoordinates | null)[] | null;
  regionId: number | null;
  districtId: number | null;
  kioskGeoFenceRadius: number | null;
  isTCSEnabled: boolean | null;
}

export interface GetAllLofasFiltered {
  getAllLofasFiltered: (GetAllLofasFiltered_getAllLofasFiltered | null)[] | null;
}

export interface GetAllLofasFilteredVariables {
  input?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllMessages
// ====================================================

export interface GetAllMessages_getAllMessages_driver {
  __typename: "ConversationDriver";
  id: number | null;
  name: string | null;
  driverCompanyName: string | null;
  isDeleted: boolean | null;
  isAssigned: boolean | null;
  isManual: boolean | null;
  isAvailable: boolean | null;
  isPreferred: boolean | null;
  isShiftStarted: boolean | null;
  driverCellNumber: string | null;
}

export interface GetAllMessages_getAllMessages_message {
  __typename: "Messages";
  id: number | null;
  creationDate: string | null;
  bodyMessage: string | null;
  messageType: string | null;
}

export interface GetAllMessages_getAllMessages {
  __typename: "MessagesConversation";
  messageId: number | null;
  conversationId: string | null;
  creationDate: string | null;
  conversationName: string | null;
  isFromDriver: boolean | null;
  loadId: number | null;
  lastMessageRead: number | null;
  bodyMessage: string | null;
  messageType: string | null;
  driverName: string | null;
  deadLineDateTime: string | null;
  wasDelivered: boolean | null;
  isDeleted: boolean | null;
  isGrupal: boolean | null;
  driver: GetAllMessages_getAllMessages_driver | null;
  message: GetAllMessages_getAllMessages_message | null;
  totalCount: number | null;
}

export interface GetAllMessages {
  getAllMessages: (GetAllMessages_getAllMessages | null)[] | null;
}

export interface GetAllMessagesVariables {
  input?: AllMessageInput | null;
  offset?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllNotifications
// ====================================================

export interface GetAllNotifications_getAllNotifications {
  __typename: "NotificationData";
  notificationDateTime: string | null;
  loadId: number | null;
  driverId: number | null;
  secondaryDriverId: number | null;
  notificationType: string | null;
  notificationJSON: string | null;
}

export interface GetAllNotifications {
  getAllNotifications: (GetAllNotifications_getAllNotifications | null)[] | null;
}

export interface GetAllNotificationsVariables {
  input?: NotificationInput | null;
  offset?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllProppants
// ====================================================

export interface GetAllProppants_getAllProppants {
  __typename: "Proppant";
  proppantId: number | null;
  proppantName: string | null;
  extSystemName: string | null;
  extSystemReference: string | null;
}

export interface GetAllProppants {
  getAllProppants: (GetAllProppants_getAllProppants | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllProppantsByJob
// ====================================================

export interface GetAllProppantsByJob_getAllProppantsByJob {
  __typename: "Proppant";
  proppantId: number | null;
  proppantName: string | null;
}

export interface GetAllProppantsByJob {
  getAllProppantsByJob: (GetAllProppantsByJob_getAllProppantsByJob | null)[] | null;
}

export interface GetAllProppantsByJobVariables {
  jobId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllRegions
// ====================================================

export interface GetAllRegions_getAllRegions_districts {
  __typename: "District";
  id: number;
  districtName: string | null;
  regionId: number;
}

export interface GetAllRegions_getAllRegions {
  __typename: "Region";
  id: number;
  regionName: string | null;
  regionCode: number | null;
  districts: (GetAllRegions_getAllRegions_districts | null)[] | null;
}

export interface GetAllRegions {
  getAllRegions: (GetAllRegions_getAllRegions | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllStates
// ====================================================

export interface GetAllStates_getAllStates {
  __typename: "StateDetails";
  id: number | null;
  stateAcronym: string | null;
  stateName: string | null;
}

export interface GetAllStates {
  getAllStates: (GetAllStates_getAllStates | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllStatusFilter
// ====================================================

export interface GetAllStatusFilter_getAllStatusFilter {
  __typename: "FilterObjectModel_Statuses";
  id: number;
  name: string;
}

export interface GetAllStatusFilter {
  getAllStatusFilter: (GetAllStatusFilter_getAllStatusFilter | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllTrailers
// ====================================================

export interface GetAllTrailers_getAllTrailers {
  __typename: "FilterObjectModel_Trailers";
  id: number;
  name: string;
}

export interface GetAllTrailers {
  getAllTrailers: (GetAllTrailers_getAllTrailers | null)[] | null;
}

export interface GetAllTrailersVariables {
  input?: GetAllTrailersInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllTrailerTypes
// ====================================================

export interface GetAllTrailerTypes_getAllTrailerTypes {
  __typename: "FilterObjectModel_TrailerTypes";
  id: number;
  name: string;
}

export interface GetAllTrailerTypes {
  getAllTrailerTypes: (GetAllTrailerTypes_getAllTrailerTypes | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllVosUploads
// ====================================================

export interface GetAllVosUploads_getAllVosUploads {
  __typename: "GetAllVosUploadsInputResponse";
  jobId: number | null;
  wellName: string | null;
  district: string | null;
  customer: string | null;
  week1: string | null;
  downloadLinkWeek1: string | null;
  week2: string | null;
  downloadLinkWeek2: string | null;
  week3: string | null;
  downloadLinkWeek3: string | null;
  week4: string | null;
  downloadLinkWeek4: string | null;
  week5: string | null;
  downloadLinkWeek5: string | null;
  week6: string | null;
  downloadLinkWeek6: string | null;
  downloadLinkMob: string | null;
  downloadLinkDemob: string | null;
}

export interface GetAllVosUploads {
  getAllVosUploads: (GetAllVosUploads_getAllVosUploads | null)[] | null;
}

export interface GetAllVosUploadsVariables {
  input?: GetAllVosUploadsInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllYards
// ====================================================

export interface GetAllYards_getAllYards {
  __typename: "YardsResponse";
  yardId: number | null;
  yardName: string | null;
  yardType: string | null;
}

export interface GetAllYards {
  getAllYards: (GetAllYards_getAllYards | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAssestLoadsByLoadId
// ====================================================

export interface GetAssestLoadsByLoadId_getAssestLoadsByLoadId {
  __typename: "AssetLoadsResponse";
  id: number | null;
  assetLoadType: string | null;
  assetLoadTypeId: number | null;
  originType: string | null;
  originJob: string | null;
  originJobId: number | null;
  originLofa: string | null;
  originLofaId: number | null;
  originYard: string | null;
  originYardId: number | null;
  originLongitude: number | null;
  originLatitude: number | null;
  originRegion: string | null;
  originRegionId: number | null;
  originDistrict: string | null;
  originDistrictId: number | null;
  destinationType: string | null;
  destinationJob: string | null;
  destinationJobId: number | null;
  destinationLofa: string | null;
  destinationLofaId: number | null;
  destinationYard: string | null;
  destinationYardId: number | null;
  destinationLongitude: number | null;
  destinationLatitude: number | null;
  destinationRegion: string | null;
  destinationRegionId: number | null;
  destinationDistrict: string | null;
  destinationDistrictId: number | null;
  trailerType: string | null;
  trailerTypeId: number | null;
  trailer: string | null;
  trailerId: number | null;
  truckNumber: string | null;
  carrierName: string | null;
  carrierId: number | null;
  driverName: string | null;
  driverId: number | null;
  status: string | null;
  miles: number | null;
  accessorialCost: number | null;
  payCode: string | null;
  readyForDispatchDateTime: string | null;
  assignedDateTime: string | null;
  atOriginIn: string | null;
  atOriginOut: string | null;
  atDestinationIn: string | null;
  atDestinationOut: string | null;
}

export interface GetAssestLoadsByLoadId {
  getAssestLoadsByLoadId: GetAssestLoadsByLoadId_getAssestLoadsByLoadId | null;
}

export interface GetAssestLoadsByLoadIdVariables {
  loadId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAssetInfoByLoadId
// ====================================================

export interface GetAssetInfoByLoadId_getAssetInfoByLoadId {
  __typename: "AssetInfoResponse";
  assetTypeId: number | null;
  assetType: string | null;
  assetId: number | null;
  assetDescrip: string | null;
  quantity: number | null;
}

export interface GetAssetInfoByLoadId {
  getAssetInfoByLoadId: (GetAssetInfoByLoadId_getAssetInfoByLoadId | null)[] | null;
}

export interface GetAssetInfoByLoadIdVariables {
  loadId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAssetLoadListToDownload
// ====================================================

export interface GetAssetLoadListToDownload_getAssetLoadListToDownload {
  __typename: "AssetLoadManagement";
  loadId: number | null;
  carrierName: string | null;
  driverName: string | null;
  origin: string | null;
  destination: string | null;
  trailerType: string | null;
  status: string | null;
  assetLoadType: string | null;
  atOriginIn: string | null;
  atOriginOut: string | null;
  atDestinationIn: string | null;
  atDestinationOut: string | null;
  equipments: string | null;
  mobId: number | null;
  truckNumber: string | null;
  payCode: string | null;
  miles: number | null;
  accessorialCost: number | null;
  originAddress: string | null;
  destinationAddress: string | null;
  customer: string | null;
  jobName: string | null;
  region: string | null;
  district: string | null;
  districtAbbreviation: string | null;
  kronosId: string | null;
  comments: string | null;
  quantity: number | null;
}

export interface GetAssetLoadListToDownload {
  getAssetLoadListToDownload: (GetAssetLoadListToDownload_getAssetLoadListToDownload | null)[] | null;
}

export interface GetAssetLoadListToDownloadVariables {
  input?: GetFilteredAssetLoadListForDownloadInput | null;
  offset?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAssetLoadNotes
// ====================================================

export interface GetAssetLoadNotes_getAssetLoadNotes {
  __typename: "AssetLoadNotesUserDetails";
  id: number | null;
  notes: string | null;
  createdAt: string | null;
  modifiedAt: string | null;
  createdUserId: number | null;
  loadId: number | null;
  isDeleted: boolean | null;
  name: string | null;
  userName: string | null;
  email: string | null;
}

export interface GetAssetLoadNotes {
  getAssetLoadNotes: (GetAssetLoadNotes_getAssetLoadNotes | null)[] | null;
}

export interface GetAssetLoadNotesVariables {
  loadId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAvailableDriversForJob
// ====================================================

export interface GetAvailableDriversForJob_getAvailableDriversForJob {
  __typename: "DriversForJobPool";
  id: number | null;
  driverId: number;
  name: string;
  companyName: string | null;
  jobName: string | null;
  notes: string | null;
}

export interface GetAvailableDriversForJob {
  getAvailableDriversForJob: (GetAvailableDriversForJob_getAvailableDriversForJob | null)[] | null;
}

export interface GetAvailableDriversForJobVariables {
  jobId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetBoxes
// ====================================================

export interface GetBoxes_getBoxes_boxDetails {
  __typename: "BoxDetailsProps";
  boxId: number | null;
  boxDesc: string | null;
  proppantColor: string | null;
  stageSheetId: string | null;
  stageSheetColor: string | null;
  weight: number | null;
  weightRemaining: number | null;
  currentProppantWeight: number | null;
  loadId: number | null;
  doNotUse: boolean | null;
  row: string | null;
  rowId: number | null;
  column: string | null;
  columnId: number | null;
  level: string | null;
  proppantId: number | null;
  proppantDesc: string | null;
  stageSheetProppantId: string | null;
  queueDesc: string | null;
  fillPerc: number | null;
  loadWeight: number | null;
  sandTicket: string | null;
  semiAllocated: boolean | null;
  stageSheetBellyDump: (StageSheetBellyDump | null)[] | null;
}

export interface GetBoxes_getBoxes_stageSheetColors {
  __typename: "StageSheetColorsProps";
  index: number | null;
  descrip: string | null;
  color: string | null;
}

export interface GetBoxes_getBoxes_proppantColors {
  __typename: "StageSheetColorsProps";
  index: number | null;
  descrip: string | null;
  color: string | null;
}

export interface GetBoxes_getBoxes_boxStats {
  __typename: "BoxStatsProps";
  queueDescrip: string | null;
  proppantDescrip: string | null;
  weight: string | null;
  boxCount: number | null;
}

export interface GetBoxes_getBoxes {
  __typename: "GetBoxResponse";
  boxDetails: (GetBoxes_getBoxes_boxDetails | null)[] | null;
  stageSheetColors: (GetBoxes_getBoxes_stageSheetColors | null)[] | null;
  proppantColors: (GetBoxes_getBoxes_proppantColors | null)[] | null;
  boxStats: (GetBoxes_getBoxes_boxStats | null)[] | null;
  wellName: string | null;
  isBellyDump: boolean | null;
}

export interface GetBoxes {
  getBoxes: GetBoxes_getBoxes | null;
}

export interface GetBoxesVariables {
  jobId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetBoxesToEdit
// ====================================================

export interface GetBoxesToEdit_getBoxesToEdit {
  __typename: "BoxesToEdit";
  boxId: number | null;
  boxDesc: string | null;
}

export interface GetBoxesToEdit {
  getBoxesToEdit: (GetBoxesToEdit_getBoxesToEdit | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCarrierListCSV
// ====================================================

export interface GetCarrierListCSV_getCarrierListCSV {
  __typename: "CarrierListCSV";
  csv: string | null;
}

export interface GetCarrierListCSV {
  getCarrierListCSV: GetCarrierListCSV_getCarrierListCSV | null;
}

export interface GetCarrierListCSVVariables {
  input?: CarrierMasterDataInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCarrier
// ====================================================

export interface GetCarrier_getCarriers {
  __typename: "CarrierDetail";
  id: number;
  companyName: string;
  companyType: string | null;
  acronym: string | null;
}

export interface GetCarrier {
  getCarriers: (GetCarrier_getCarriers | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetConversationByDriverIdWithFilter
// ====================================================

export interface GetConversationByDriverIdWithFilter_getConversationByDriverIdWithFilter_driver {
  __typename: "ConversationDriver";
  id: number | null;
  name: string | null;
  isDeleted: boolean | null;
  isActive: boolean | null;
  isAssigned: boolean | null;
  isManual: boolean | null;
  isAvailable: boolean | null;
  driverCompanyId: number | null;
  driverCompanyName: string | null;
  isPreferred: boolean | null;
  isShiftStarted: boolean | null;
}

export interface GetConversationByDriverIdWithFilter_getConversationByDriverIdWithFilter_message {
  __typename: "Messages";
  id: number | null;
  creationDate: string | null;
  subjectMessage: string | null;
  bodyMessage: string | null;
  messageType: string | null;
  attMssageId: string | null;
  attRequestId: string | null;
}

export interface GetConversationByDriverIdWithFilter_getConversationByDriverIdWithFilter {
  __typename: "DriverConversation";
  messageId: number | null;
  conversationId: string | null;
  creationDate: string | null;
  isFromDriver: boolean | null;
  isGrupal: boolean | null;
  loadId: number | null;
  lastMessageRead: number | null;
  id: number | null;
  driverid: number | null;
  driver: GetConversationByDriverIdWithFilter_getConversationByDriverIdWithFilter_driver | null;
  message: GetConversationByDriverIdWithFilter_getConversationByDriverIdWithFilter_message | null;
  totalCount: number | null;
}

export interface GetConversationByDriverIdWithFilter {
  getConversationByDriverIdWithFilter: (GetConversationByDriverIdWithFilter_getConversationByDriverIdWithFilter | null)[] | null;
}

export interface GetConversationByDriverIdWithFilterVariables {
  input?: DriverConversationInput | null;
  offset?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetConversationById
// ====================================================

export interface GetConversationById_getConversationById_driver {
  __typename: "ConversationDriver";
  id: number | null;
  name: string | null;
  driverCompanyName: string | null;
}

export interface GetConversationById_getConversationById_message {
  __typename: "Messages";
  id: number | null;
  creationDate: string | null;
  bodyMessage: string | null;
  messageType: string | null;
}

export interface GetConversationById_getConversationById {
  __typename: "Conversation";
  messageId: number | null;
  conversationId: string | null;
  creationDate: string | null;
  conversationName: string | null;
  isFromDriver: boolean | null;
  loadId: number | null;
  isGrupal: boolean | null;
  lastMessageRead: number | null;
  id: number | null;
  driver: GetConversationById_getConversationById_driver | null;
  message: GetConversationById_getConversationById_message | null;
  totalCount: number | null;
}

export interface GetConversationById {
  getConversationById: (GetConversationById_getConversationById | null)[] | null;
}

export interface GetConversationByIdVariables {
  input?: ConversationByIdInput | null;
  offset?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetConversationPreviewByUserId
// ====================================================

export interface GetConversationPreviewByUserId_getConversationPreviewByUserId_drivers {
  __typename: "Drivers";
  name: string | null;
  id: number | null;
  driverCompanyId: number | null;
}

export interface GetConversationPreviewByUserId_getConversationPreviewByUserId {
  __typename: "ConversationPreview";
  conversationId: string | null;
  conversationName: string | null;
  creationDate: string | null;
  messageId: number | null;
  drivers: (GetConversationPreviewByUserId_getConversationPreviewByUserId_drivers | null)[] | null;
  driverName: string | null;
  lastMessageRead: boolean | null;
  totalCount: number | null;
}

export interface GetConversationPreviewByUserId {
  getConversationPreviewByUserId: (GetConversationPreviewByUserId_getConversationPreviewByUserId | null)[] | null;
}

export interface GetConversationPreviewByUserIdVariables {
  input?: ConversationPreviewInput | null;
  offset?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetDemobDetails
// ====================================================

export interface GetDemobDetails_getDemobDetails_stats {
  __typename: "DemobDetailsStat";
  assetTypeId: number | null;
  assetType: string | null;
  plannedQty: number | null;
  availableQty: number | null;
  created: number | null;
  readyForDispatch: number | null;
  inRoute: number | null;
  delivered: number | null;
  actualQty: number | null;
  additionalNeeded: number | null;
}

export interface GetDemobDetails_getDemobDetails_jobInfo {
  __typename: "DemobDetailsJobInfo";
  mobStatus: string | null;
  mobDate: string | null;
  mobEndDate: string | null;
  leapFrog: boolean | null;
}

export interface GetDemobDetails_getDemobDetails {
  __typename: "GetDemobDetailsResponse";
  stats: (GetDemobDetails_getDemobDetails_stats | null)[] | null;
  jobInfo: GetDemobDetails_getDemobDetails_jobInfo | null;
}

export interface GetDemobDetails {
  getDemobDetails: GetDemobDetails_getDemobDetails | null;
}

export interface GetDemobDetailsVariables {
  input?: GetDemobDetailsInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetDetailsForStageSheet
// ====================================================

export interface GetDetailsForStageSheet_getDetailsForStageSheet_stageStatus {
  __typename: "StageStatusProps";
  stageId: number | null;
  status: string | null;
  wellHead: string | null;
}

export interface GetDetailsForStageSheet_getDetailsForStageSheet {
  __typename: "DetailsForStageSheet";
  wellheadStages: string | null;
  jobId: number;
  wellName: string;
  stageStatus: (GetDetailsForStageSheet_getDetailsForStageSheet_stageStatus | null)[] | null;
}

export interface GetDetailsForStageSheet {
  getDetailsForStageSheet: GetDetailsForStageSheet_getDetailsForStageSheet | null;
}

export interface GetDetailsForStageSheetVariables {
  stageSheetId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetDriverActivity
// ====================================================

export interface GetDriverActivity_getDriverActivity_notes {
  __typename: "DriverLoadNote";
  id: number | null;
  loadId: number | null;
  notes: string | null;
  createDate: string | null;
  name: string | null;
}

export interface GetDriverActivity_getDriverActivity {
  __typename: "DriverActivityResponse";
  driverName: string | null;
  lofaName: string | null;
  status: string | null;
  acceptTime: string | null;
  etaLoading: string | null;
  etaLoaded: string | null;
  etaOnsite: string | null;
  etaDelivered: string | null;
  loadId: number | null;
  overdueAtLofaIn: string | null;
  overdueAtLofaOut: string | null;
  overdueAtDestinationIn: string | null;
  overdueAtDestinationOut: string | null;
  isOverdue: string | null;
  proppantName: string | null;
  checkInWithBellyDump: boolean | null;
  notes: (GetDriverActivity_getDriverActivity_notes | null)[] | null;
}

export interface GetDriverActivity {
  getDriverActivity: (GetDriverActivity_getDriverActivity | null)[] | null;
}

export interface GetDriverActivityVariables {
  input?: DriverActivityInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetDriverByCellPhone
// ====================================================

export interface GetDriverByCellPhone_getDriverByCellPhone {
  __typename: "DriverByCellPhoneOutput";
  driverId: number;
  driverName: string | null;
  driverCompany: string | null;
  regionId: number | null;
}

export interface GetDriverByCellPhone {
  getDriverByCellPhone: (GetDriverByCellPhone_getDriverByCellPhone | null)[] | null;
}

export interface GetDriverByCellPhoneVariables {
  input?: CellPhoneInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getDriverCanBeSetInactive
// ====================================================

export interface getDriverCanBeSetInactive_getDriverCanBeSetInactive {
  __typename: "DriverInactive";
  canBeSetInactive: boolean | null;
}

export interface getDriverCanBeSetInactive {
  getDriverCanBeSetInactive: getDriverCanBeSetInactive_getDriverCanBeSetInactive;
}

export interface getDriverCanBeSetInactiveVariables {
  carrierId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetDriverCompanyReferenceByDriver
// ====================================================

export interface GetDriverCompanyReferenceByDriver_getDriverCompanyReferenceByDriver {
  __typename: "DriverCompanyReference";
  id: number | null;
  driverId: number | null;
  driverCompanyId: number | null;
  updatedDate: string | null;
  updatedBy: string | null;
  companyName: string | null;
}

export interface GetDriverCompanyReferenceByDriver {
  getDriverCompanyReferenceByDriver: (GetDriverCompanyReferenceByDriver_getDriverCompanyReferenceByDriver | null)[] | null;
}

export interface GetDriverCompanyReferenceByDriverVariables {
  driverId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetDriverDistance
// ====================================================

export interface GetDriverDistance_getDriverDistance {
  __typename: "DistanceDriverResponse";
  driverId: number | null;
  driverLat: number | null;
  driverLong: number | null;
  wellLat: number | null;
  wellLong: number | null;
  lofaLat: number | null;
  lofaLong: number | null;
  distanceToLofa: number | null;
  distanceToWellsite: number | null;
  timeToDestinationInSeconds: number | null;
  timeToDestinationInMinutes: number | null;
}

export interface GetDriverDistance {
  getDriverDistance: GetDriverDistance_getDriverDistance | null;
}

export interface GetDriverDistanceVariables {
  input?: DistanceDriverInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetDriverLocations
// ====================================================

export interface GetDriverLocations_getDriverLocations {
  __typename: "DriverLocationsResponse";
  latitude: number | null;
  longitude: number | null;
  locationTimestamp: string | null;
}

export interface GetDriverLocations {
  getDriverLocations: (GetDriverLocations_getDriverLocations | null)[] | null;
}

export interface GetDriverLocationsVariables {
  input?: DriverLocationsInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetDriversByRegion
// ====================================================

export interface GetDriversByRegion_getDriversByRegion {
  __typename: "DriversByRegion";
  id: number | null;
  driverName: string | null;
  trailerId: number | null;
  trailerDescrip: string | null;
}

export interface GetDriversByRegion {
  getDriversByRegion: (GetDriversByRegion_getDriversByRegion | null)[] | null;
}

export interface GetDriversByRegionVariables {
  input?: GetDriversByRegionInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetDriversInStandby
// ====================================================

export interface GetDriversInStandby_getDriversInStandby {
  __typename: "DriversInStandbyResponse";
  driverId: number | null;
  driverName: string | null;
  carrierName: string | null;
  driverPoolNotes: string | null;
  loadRequested: number | null;
  loadRejected: number | null;
  loadDelivered: number | null;
  onShift: number | null;
  assignedTime: string | null;
  distanceToLofa: string | null;
  checkInWithBellyDump: boolean | null;
  isAvailable: boolean | null;
}

export interface GetDriversInStandby {
  getDriversInStandby: (GetDriversInStandby_getDriversInStandby | null)[] | null;
}

export interface GetDriversInStandbyVariables {
  jobId?: number | null;
  lofaId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEmptyBoxes
// ====================================================

export interface GetEmptyBoxes_getEmptyBoxes_emptyBoxDetails {
  __typename: "GetEmptyBoxProps";
  boxId: number | null;
  boxDesc: string | null;
}

export interface GetEmptyBoxes_getEmptyBoxes {
  __typename: "GetEmptyBoxResponse";
  emptyBoxDetails: (GetEmptyBoxes_getEmptyBoxes_emptyBoxDetails | null)[] | null;
}

export interface GetEmptyBoxes {
  getEmptyBoxes: GetEmptyBoxes_getEmptyBoxes | null;
}

export interface GetEmptyBoxesVariables {
  jobId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEquipmentLoggers
// ====================================================

export interface GetEquipmentLoggers_getEquipmentLoggers {
  __typename: "EquipmentLogger";
  id: number;
  message: string;
  creationDate: string;
  createdBy: number | null;
  creatorName: string | null;
  assetLoadId: number;
  systemType: string | null;
}

export interface GetEquipmentLoggers {
  getEquipmentLoggers: (GetEquipmentLoggers_getEquipmentLoggers | null)[] | null;
}

export interface GetEquipmentLoggersVariables {
  input?: EquipmentLoggerSearchInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEquipmentsByAssetType
// ====================================================

export interface GetEquipmentsByAssetType_getEquipmentsByAssetType {
  __typename: "FilterObjectModel_EquipmentByAssetTypes";
  id: number;
  name: string;
}

export interface GetEquipmentsByAssetType {
  getEquipmentsByAssetType: (GetEquipmentsByAssetType_getEquipmentsByAssetType | null)[] | null;
}

export interface GetEquipmentsByAssetTypeVariables {
  assetType?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEquipmentsInfo
// ====================================================

export interface GetEquipmentsInfo_getEquipmentsInfo_sandbox {
  __typename: "EquipmentsInfoType";
  itemId: number | null;
  descrip: string | null;
  status: string | null;
}

export interface GetEquipmentsInfo_getEquipmentsInfo_stand {
  __typename: "EquipmentsInfoType";
  itemId: number | null;
  descrip: string | null;
  status: string | null;
}

export interface GetEquipmentsInfo_getEquipmentsInfo_forklift {
  __typename: "EquipmentsInfoType";
  itemId: number | null;
  descrip: string | null;
  status: string | null;
}

export interface GetEquipmentsInfo_getEquipmentsInfo_auriser {
  __typename: "EquipmentsInfoType";
  itemId: number | null;
  descrip: string | null;
  status: string | null;
}

export interface GetEquipmentsInfo_getEquipmentsInfo_dustcollector {
  __typename: "EquipmentsInfoType";
  itemId: number | null;
  descrip: string | null;
  status: string | null;
}

export interface GetEquipmentsInfo_getEquipmentsInfo_generator {
  __typename: "EquipmentsInfoType";
  itemId: number | null;
  descrip: string | null;
  status: string | null;
}

export interface GetEquipmentsInfo_getEquipmentsInfo_telehandler {
  __typename: "EquipmentsInfoType";
  itemId: number | null;
  descrip: string | null;
  status: string | null;
}

export interface GetEquipmentsInfo_getEquipmentsInfo_frontendloader {
  __typename: "EquipmentsInfoType";
  itemId: number | null;
  descrip: string | null;
  status: string | null;
}

export interface GetEquipmentsInfo_getEquipmentsInfo_skidsteer {
  __typename: "EquipmentsInfoType";
  itemId: number | null;
  descrip: string | null;
  status: string | null;
}

export interface GetEquipmentsInfo_getEquipmentsInfo_standbase {
  __typename: "EquipmentsInfoType";
  itemId: number | null;
  descrip: string | null;
  status: string | null;
}

export interface GetEquipmentsInfo_getEquipmentsInfo_chassis {
  __typename: "EquipmentsInfoType";
  itemId: number | null;
  descrip: string | null;
  status: string | null;
}

export interface GetEquipmentsInfo_getEquipmentsInfo_otherequipment {
  __typename: "EquipmentsInfoType";
  itemId: number | null;
  descrip: string | null;
  status: string | null;
}

export interface GetEquipmentsInfo_getEquipmentsInfo_mobileoffice {
  __typename: "EquipmentsInfoType";
  itemId: number | null;
  descrip: string | null;
  status: string | null;
}

export interface GetEquipmentsInfo_getEquipmentsInfo_auger {
  __typename: "EquipmentsInfoType";
  itemId: number | null;
  descrip: string | null;
  status: string | null;
}

export interface GetEquipmentsInfo_getEquipmentsInfo_guardian {
  __typename: "EquipmentsInfoType";
  itemId: number | null;
  descrip: string | null;
  status: string | null;
}

export interface GetEquipmentsInfo_getEquipmentsInfo_aquabox {
  __typename: "EquipmentsInfoType";
  itemId: number | null;
  descrip: string | null;
  status: string | null;
}

export interface GetEquipmentsInfo_getEquipmentsInfo_cradle {
  __typename: "EquipmentsInfoType";
  itemId: number | null;
  descrip: string | null;
  status: string | null;
}

export interface GetEquipmentsInfo_getEquipmentsInfo {
  __typename: "GetEquipmentsInfoResponse";
  sandbox: (GetEquipmentsInfo_getEquipmentsInfo_sandbox | null)[] | null;
  stand: (GetEquipmentsInfo_getEquipmentsInfo_stand | null)[] | null;
  forklift: (GetEquipmentsInfo_getEquipmentsInfo_forklift | null)[] | null;
  auriser: (GetEquipmentsInfo_getEquipmentsInfo_auriser | null)[] | null;
  dustcollector: (GetEquipmentsInfo_getEquipmentsInfo_dustcollector | null)[] | null;
  generator: (GetEquipmentsInfo_getEquipmentsInfo_generator | null)[] | null;
  telehandler: (GetEquipmentsInfo_getEquipmentsInfo_telehandler | null)[] | null;
  frontendloader: (GetEquipmentsInfo_getEquipmentsInfo_frontendloader | null)[] | null;
  skidsteer: (GetEquipmentsInfo_getEquipmentsInfo_skidsteer | null)[] | null;
  standbase: (GetEquipmentsInfo_getEquipmentsInfo_standbase | null)[] | null;
  chassis: (GetEquipmentsInfo_getEquipmentsInfo_chassis | null)[] | null;
  otherequipment: (GetEquipmentsInfo_getEquipmentsInfo_otherequipment | null)[] | null;
  mobileoffice: (GetEquipmentsInfo_getEquipmentsInfo_mobileoffice | null)[] | null;
  auger: (GetEquipmentsInfo_getEquipmentsInfo_auger | null)[] | null;
  guardian: (GetEquipmentsInfo_getEquipmentsInfo_guardian | null)[] | null;
  aquabox: (GetEquipmentsInfo_getEquipmentsInfo_aquabox | null)[] | null;
  cradle: (GetEquipmentsInfo_getEquipmentsInfo_cradle | null)[] | null;
}

export interface GetEquipmentsInfo {
  getEquipmentsInfo: GetEquipmentsInfo_getEquipmentsInfo | null;
}

export interface GetEquipmentsInfoVariables {
  input?: GetEquipmentsInfoInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetExportDataForDownload
// ====================================================

export interface GetExportDataForDownload_getExportDataForDownload_loads {
  __typename: "AssetLoadManagement";
  loadId: number | null;
  carrierName: string | null;
  driverName: string | null;
  origin: string | null;
  destination: string | null;
  trailerType: string | null;
  status: string | null;
  assetLoadType: string | null;
  atOriginIn: string | null;
  atOriginOut: string | null;
  atDestinationIn: string | null;
  atDestinationOut: string | null;
  equipments: string | null;
  equipmentDetails: string | null;
  mobId: number | null;
  truckNumber: string | null;
  payCode: string | null;
  miles: number | null;
  accessorialCost: number | null;
  originAddress: string | null;
  destinationAddress: string | null;
  customer: string | null;
  jobName: string | null;
  region: string | null;
  district: string | null;
  districtAbbreviation: string | null;
  kronosId: string | null;
  comments: string | null;
}

export interface GetExportDataForDownload_getExportDataForDownload_filterValues {
  __typename: "filterValuesTypeProps";
  filterName: string | null;
  filterValues: string | null;
}

export interface GetExportDataForDownload_getExportDataForDownload {
  __typename: "GetExportDataForDownloadRes";
  loads: (GetExportDataForDownload_getExportDataForDownload_loads | null)[] | null;
  filterValues: (GetExportDataForDownload_getExportDataForDownload_filterValues | null)[] | null;
}

export interface GetExportDataForDownload {
  getExportDataForDownload: GetExportDataForDownload_getExportDataForDownload | null;
}

export interface GetExportDataForDownloadVariables {
  input?: GetFilteredAssetLoadListForDownloadInput | null;
  offset?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetFieldOpBoxes
// ====================================================

export interface GetFieldOpBoxes_getFieldOpBoxes_boxDetails {
  __typename: "BoxDetailsProps";
  boxId: number | null;
  boxDesc: string | null;
  doNotUse: boolean | null;
}

export interface GetFieldOpBoxes_getFieldOpBoxes {
  __typename: "GetBoxResponse";
  boxDetails: (GetFieldOpBoxes_getFieldOpBoxes_boxDetails | null)[] | null;
}

export interface GetFieldOpBoxes {
  getFieldOpBoxes: GetFieldOpBoxes_getFieldOpBoxes | null;
}

export interface GetFieldOpBoxesVariables {
  jobId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetFilteredAssetLoadManagements
// ====================================================

export interface GetFilteredAssetLoadManagements_getFilteredAssetLoadManagements {
  __typename: "AssetLoadManagement";
  loadId: number | null;
  carrierName: string | null;
  driverName: string | null;
  origin: string | null;
  destination: string | null;
  trailerType: string | null;
  status: string | null;
  assetLoadType: string | null;
  atOriginIn: string | null;
  atOriginOut: string | null;
  atDestinationIn: string | null;
  atDestinationOut: string | null;
  equipments: string | null;
  mobId: number | null;
  truckNumber: string | null;
  payCode: string | null;
  miles: number | null;
  accessorialCost: number | null;
  originAddress: string | null;
  destinationAddress: string | null;
  customer: string | null;
  jobName: string | null;
  region: string | null;
  district: string | null;
  districtAbbreviation: string | null;
  kronosId: string | null;
  comments: string | null;
}

export interface GetFilteredAssetLoadManagements {
  getFilteredAssetLoadManagements: (GetFilteredAssetLoadManagements_getFilteredAssetLoadManagements | null)[] | null;
}

export interface GetFilteredAssetLoadManagementsVariables {
  input?: GetFilteredAssetLoadListInput | null;
  offset?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetFilteredLoadManagements
// ====================================================

export interface GetFilteredLoadManagements_getFilteredLoadManagements {
  __typename: "LoadManagementLookup";
  atLofaIn: string | null;
  atLofaOut: string | null;
  atDestinationIn: string | null;
  atDestinationOut: string | null;
  truckNumber: string | null;
  chassisNumber: string | null;
  sandTicket: string;
  transportationPo: string | null;
  jobSummaryId: number;
  loadId: number;
  lofaId: number;
  boxNumber: string;
  carrierName: string | null;
  driverCompanyId: number | null;
  driverId: number | null;
  driverName: string | null;
  driverLoadStatus: string | null;
  loadingFacility: string | null;
  loadNumber: number;
  proppantName: string | null;
  status: string;
  weight: number | null;
  regionName: string | null;
  isSplit: boolean | null;
  jobId: number | null;
  districtName: string | null;
  customerName: string | null;
  regionId: number | null;
  sandPO: string | null;
  secondaryDriverId: number | null;
  secondaryDriverLoadStatus: string | null;
  jobName: string | null;
  rejectReason: string | null;
  assignedDateTime: string | null;
  rejectedDateTime: string | null;
  userName: string | null;
  rejectedDriverName: string | null;
  dateRangeFilter?: string | null;
}

export interface GetFilteredLoadManagements {
  getFilteredLoadManagements: (GetFilteredLoadManagements_getFilteredLoadManagements | null)[] | null;
}

export interface GetFilteredLoadManagementsVariables {
  input?: GetFilteredLoadListInput | null;
  offset?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetFilteredYards
// ====================================================

export interface GetFilteredYards_getFilteredYards_yardPolygonCoordinates {
  __typename: "polygnCoordinates";
  lat: number | null;
  lng: number | null;
}

export interface GetFilteredYards_getFilteredYards {
  __typename: "GetFilteredYardsResponse";
  yardName: string | null;
  id: number | null;
  longitude: number | null;
  latitude: number | null;
  yardType: string | null;
  yardTypeId: number | null;
  addressStreet: string | null;
  city: string | null;
  zip: string | null;
  phoneNumber: string | null;
  description: string | null;
  stateId: number | null;
  utm: string | null;
  directions: string | null;
  geoFenceType: string | null;
  geoFenceRadius: number | null;
  yardPolygonCoordinates: (GetFilteredYards_getFilteredYards_yardPolygonCoordinates | null)[] | null;
  regionId: number | null;
  districtId: number | null;
}

export interface GetFilteredYards {
  getFilteredYards: (GetFilteredYards_getFilteredYards | null)[] | null;
}

export interface GetFilteredYardsVariables {
  input?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetJobFiltersList
// ====================================================

export interface GetJobFiltersList_getJobFiltersList_customers {
  __typename: "FilterObjectModel_Customer";
  id: number;
  name: string;
}

export interface GetJobFiltersList_getJobFiltersList_districts {
  __typename: "FilterObjectModel_District";
  id: number;
  name: string;
}

export interface GetJobFiltersList_getJobFiltersList_regions {
  __typename: "FilterObjectModel_Region";
  id: number;
  name: string;
}

export interface GetJobFiltersList_getJobFiltersList_statuses {
  __typename: "FilterObjectModel_Status";
  id: number;
  name: string;
}

export interface GetJobFiltersList_getJobFiltersList {
  __typename: "JobFilterList";
  customers: GetJobFiltersList_getJobFiltersList_customers[];
  districts: GetJobFiltersList_getJobFiltersList_districts[];
  regions: GetJobFiltersList_getJobFiltersList_regions[];
  statuses: GetJobFiltersList_getJobFiltersList_statuses[];
}

export interface GetJobFiltersList {
  getJobFiltersList: GetJobFiltersList_getJobFiltersList;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getInventoryExtract
// ====================================================

export interface getInventoryExtract_getInventoryExtract_boxDetails {
  __typename: "InventoryBoxVM";
  boxId: number | null;
  boxDesc: string | null;
  padLocation: string | null;
  doNotUse: boolean | null;
  weight: string | null;
  weightDelivered: string | null;
  weightRemaining: string | null;
  proppantDesc: string | null;
  stageSheetId: number | null;
  associatedtoStage: string | null;
  stageDetails: string | null;
  sandTicket: string | null;
  sandPO: string | null;
  loadId: string | null;
  boxStatus: string | null;
  driverName: string | null;
  truckNumber: string | null;
  chassisNumber: string | null;
  companyName: string | null;
  grossWeight: string | null;
  tareWeight: string | null;
  lofa: string | null;
  bellyDumpDetails: string | null;
}

export interface getInventoryExtract_getInventoryExtract {
  __typename: "InventoryExtractResponse";
  boxDetails: (getInventoryExtract_getInventoryExtract_boxDetails | null)[] | null;
}

export interface getInventoryExtract {
  getInventoryExtract: getInventoryExtract_getInventoryExtract | null;
}

export interface getInventoryExtractVariables {
  jobId?: number | null;
  key?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetJobImages
// ====================================================

export interface GetJobImages_getJobImages {
  __typename: "jobImages";
  id: number | null;
  name: string | null;
  imageName: string | null;
  uploadedBy: string | null;
  uploadDate: string | null;
  downloadLink: string | null;
}

export interface GetJobImages {
  getJobImages: (GetJobImages_getJobImages | null)[] | null;
}

export interface GetJobImagesVariables {
  jobId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetJobLogMetaData
// ====================================================

export interface GetJobLogMetaData_getJobLogMetaData_types {
  __typename: "JobLogIssueTypeProps";
  id: number | null;
  descrip: string | null;
}

export interface GetJobLogMetaData_getJobLogMetaData_issues {
  __typename: "JobLogIssueProps";
  jobLogIssueId: number | null;
  descrip: string | null;
  jobLogTypeId: number | null;
}

export interface GetJobLogMetaData_getJobLogMetaData_rootcauses {
  __typename: "JobLogRootcauseProps";
  id: number | null;
  descrip: string | null;
}

export interface GetJobLogMetaData_getJobLogMetaData_locationLOFAs {
  __typename: "JobLoglocationLOFAsProps";
  id: number | null;
  descrip: string | null;
}

export interface GetJobLogMetaData_getJobLogMetaData {
  __typename: "GetJobLogMetaDataResponse";
  types: (GetJobLogMetaData_getJobLogMetaData_types | null)[] | null;
  issues: (GetJobLogMetaData_getJobLogMetaData_issues | null)[] | null;
  rootcauses: (GetJobLogMetaData_getJobLogMetaData_rootcauses | null)[] | null;
  locationLOFAs: (GetJobLogMetaData_getJobLogMetaData_locationLOFAs | null)[] | null;
}

export interface GetJobLogMetaData {
  getJobLogMetaData: GetJobLogMetaData_getJobLogMetaData | null;
}

export interface GetJobLogMetaDataVariables {
  jobId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetJobLogNotes
// ====================================================

export interface GetJobLogNotes_getJobLogNotes {
  __typename: "JobLogNotes";
  id: number | null;
  notes: string | null;
  dateCreated: string | null;
  createdBy: string | null;
}

export interface GetJobLogNotes {
  getJobLogNotes: (GetJobLogNotes_getJobLogNotes | null)[] | null;
}

export interface GetJobLogNotesVariables {
  input?: GetJobLogNotesInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetJobLogs
// ====================================================

export interface GetJobLogs_getJobLogs_details {
  __typename: "JobLogsType";
  id: number | null;
  jobLogIssueId: number | null;
  jobLogIssue: string | null;
  jobLogTypeId: number | null;
  jobLogType: string | null;
  jobId: number | null;
  status: string | null;
  startDate: string | null;
  endDate: string | null;
  estimatedDowntime: number | null;
  jobStageId: number | null;
  stage: string | null;
  loadId: number | null;
  notes: string | null;
  locationLofa: string | null;
  lofa: string | null;
  amount: number | null;
  rootCauseId: number | null;
  rootCause: string | null;
  correctiveAction: string | null;
  dateCreated: string | null;
  dateUpdated: string | null;
  createdBy: string | null;
  updatedBy: string | null;
  wellName: string | null;
  overallStage: string | null;
  totalSandPumped: string | null;
  duration: string | null;
  allNotes: string | null;
}

export interface GetJobLogs_getJobLogs {
  __typename: "GetJobLogsResponse";
  details: (GetJobLogs_getJobLogs_details | null)[] | null;
  isLastPage: boolean | null;
}

export interface GetJobLogs {
  getJobLogs: GetJobLogs_getJobLogs | null;
}

export interface GetJobLogsVariables {
  input?: GetJobLogsInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetJobLogsDetails
// ====================================================

export interface GetJobLogsDetails_getJobLogsDetails {
  __typename: "JobLogsType";
  id: number | null;
  jobLogIssueId: number | null;
  jobLogIssue: string | null;
  jobLogTypeId: number | null;
  jobLogType: string | null;
  jobId: number | null;
  status: string | null;
  startDate: string | null;
  endDate: string | null;
  estimatedDowntime: number | null;
  jobStageId: number | null;
  stage: string | null;
  loadId: number | null;
  notes: string | null;
  locationLofa: string | null;
  lofa: string | null;
  amount: number | null;
  rootCauseId: number | null;
  rootCause: string | null;
  correctiveAction: string | null;
  dateCreated: string | null;
  dateUpdated: string | null;
  createdBy: string | null;
  updatedBy: string | null;
  wellName: string | null;
  overallStage: string | null;
  totalSandPumped: string | null;
}

export interface GetJobLogsDetails {
  getJobLogsDetails: (GetJobLogsDetails_getJobLogsDetails | null)[] | null;
}

export interface GetJobLogsDetailsVariables {
  jobId?: number | null;
  tzinfo?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetJobLogSummary
// ====================================================

export interface GetJobLogSummary_getJobLogSummary_logCountSummary_subCategory {
  __typename: "SubCategoryProps";
  descrip: string | null;
  total: number | null;
}

export interface GetJobLogSummary_getJobLogSummary_logCountSummary {
  __typename: "LogCountSummaryProps";
  issue: string | null;
  subCategory: (GetJobLogSummary_getJobLogSummary_logCountSummary_subCategory | null)[] | null;
}

export interface GetJobLogSummary_getJobLogSummary_logTimeSummary_subCategory {
  __typename: "SubCategoryProps";
  descrip: string | null;
  total: number | null;
}

export interface GetJobLogSummary_getJobLogSummary_logTimeSummary {
  __typename: "LogCountSummaryProps";
  issue: string | null;
  subCategory: (GetJobLogSummary_getJobLogSummary_logTimeSummary_subCategory | null)[] | null;
}

export interface GetJobLogSummary_getJobLogSummary_logTypesSummary {
  __typename: "LogTypesSummaryProps";
  category: string | null;
  totalCount: number | null;
  totalTime: number | null;
}

export interface GetJobLogSummary_getJobLogSummary_pivotData {
  __typename: "PivotDataProps";
  jobLogTypeId: number | null;
  jobLogType: string | null;
  countonDate1: number | null;
  countonDate2: number | null;
  countonDate3: number | null;
  countonDate4: number | null;
  countonDate5: number | null;
  countonDate6: number | null;
  countonDate7: number | null;
  countonDate8: number | null;
  countonDate9: number | null;
  countonDate10: number | null;
  countonDate11: number | null;
  countonDate12: number | null;
  countonDate13: number | null;
  countonDate14: number | null;
}

export interface GetJobLogSummary_getJobLogSummary_stageStEndSummary {
  __typename: "StageStEndSummaryProps";
  wellHead: string | null;
  statsType: string | null;
  statsonDate1: number | null;
  statsonDate2: number | null;
  statsonDate3: number | null;
  statsonDate4: number | null;
  statsonDate5: number | null;
  statsonDate6: number | null;
  statsonDate7: number | null;
  statsonDate8: number | null;
  statsonDate9: number | null;
  statsonDate10: number | null;
  statsonDate11: number | null;
  statsonDate12: number | null;
  statsonDate13: number | null;
  statsonDate14: number | null;
}

export interface GetJobLogSummary_getJobLogSummary {
  __typename: "GetJobLogSummaryResponse";
  wellName: string | null;
  spillsCount: number | null;
  logCountSummary: (GetJobLogSummary_getJobLogSummary_logCountSummary | null)[] | null;
  logTimeSummary: (GetJobLogSummary_getJobLogSummary_logTimeSummary | null)[] | null;
  logTypesSummary: (GetJobLogSummary_getJobLogSummary_logTypesSummary | null)[] | null;
  pivotData: (GetJobLogSummary_getJobLogSummary_pivotData | null)[] | null;
  stageStEndSummary: (GetJobLogSummary_getJobLogSummary_stageStEndSummary | null)[] | null;
}

export interface GetJobLogSummary {
  getJobLogSummary: GetJobLogSummary_getJobLogSummary | null;
}

export interface GetJobLogSummaryVariables {
  input?: GetJobLogSummaryInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetJobNotes
// ====================================================

export interface GetJobNotes_getJobNotes {
  __typename: "JobNotesUserDetails";
  notesId: number | null;
  notes: string | null;
  createdAt: string | null;
  modifiedAt: string | null;
  createdUserId: number | null;
  jobId: number | null;
  isDeleted: boolean | null;
  name: string | null;
  userName: string | null;
  email: string | null;
}

export interface GetJobNotes {
  getJobNotes: (GetJobNotes_getJobNotes | null)[] | null;
}

export interface GetJobNotesVariables {
  jobId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetFullJobProfile
// ====================================================

export interface GetFullJobProfile_getJobProfile_customerDetails {
  __typename: "CustomerDetails";
  customerId: number | null;
  customerName: string | null;
  customerPO: string | null;
  epCompany: string | null;
  crew: string | null;
  contact: string | null;
  phoneNumber: string | null;
}

export interface GetFullJobProfile_getJobProfile_jobDetails_district {
  __typename: "DistrictDetails";
  districtName: string | null;
  id: number | null;
  regionId: number | null;
  extSystemName: string | null;
  extSystemReference: string | null;
  districtAbbreviation: string | null;
}

export interface GetFullJobProfile_getJobProfile_jobDetails_region {
  __typename: "RegionDetails";
  regionName: string | null;
  id: number | null;
  extSystemName: string | null;
  extSystemReference: string | null;
  regionCode: string | null;
}

export interface GetFullJobProfile_getJobProfile_jobDetails_state {
  __typename: "StateDetails";
  id: number | null;
  stateName: string | null;
  stateAcronym: string | null;
}

export interface GetFullJobProfile_getJobProfile_jobDetails_status {
  __typename: "StatusDetails";
  statusId: number | null;
  status: string | null;
}

export interface GetFullJobProfile_getJobProfile_jobDetails_wellsitePolygonCoordinates {
  __typename: "polygonCoordinates";
  lat: number | null;
  lng: number | null;
}

export interface GetFullJobProfile_getJobProfile_jobDetails_stagingPolygonCoordinates {
  __typename: "polygonCoordinates";
  lat: number | null;
  lng: number | null;
}

export interface GetFullJobProfile_getJobProfile_jobDetails {
  __typename: "JobDetails";
  addressLine1: string | null;
  addressLine2: string | null;
  city: string | null;
  contact: string | null;
  directions: string | null;
  district: GetFullJobProfile_getJobProfile_jobDetails_district | null;
  jdeNumber: string | null;
  jobId: number | null;
  jobName: string | null;
  latitude: number | null;
  longitude: number | null;
  region: GetFullJobProfile_getJobProfile_jobDetails_region | null;
  state: GetFullJobProfile_getJobProfile_jobDetails_state | null;
  status: GetFullJobProfile_getJobProfile_jobDetails_status | null;
  wellEndDate: string | null;
  wellStartDate: string | null;
  actualStartDate: string | null;
  actualEndDate: string | null;
  zip: string | null;
  mobDate: string | null;
  crewId: number | null;
  epCompanyId: number | null;
  accessorialId: number | null;
  miles: string | null;
  accessorialName: string | null;
  wellsiteGeoFenceType: string | null;
  wellsiteGeoFenceRadius: number | null;
  wellsitePolygonCoordinates: (GetFullJobProfile_getJobProfile_jobDetails_wellsitePolygonCoordinates | null)[] | null;
  stagingLatitude: number | null;
  stagingLongitude: number | null;
  stagingGeoFenceType: string | null;
  stagingGeoFenceRadius: number | null;
  stagingPolygonCoordinates: (GetFullJobProfile_getJobProfile_jobDetails_stagingPolygonCoordinates | null)[] | null;
  isBellyDump?: boolean | null;
}

export interface GetFullJobProfile_getJobProfile_pumpScheduleSummary_proppants {
  __typename: "PumpScheduleProppant";
  id: string;
  pumpScheduleId: number | null;
  proppantId: number | null;
  proppantName: string | null;
  totalVolume: number | null;
  volumePerBox: number | null;
  volumePerStage: number | null;
  boxesPerStage: number | null;
  boxesPerWell: number | null;
}

export interface GetFullJobProfile_getJobProfile_pumpScheduleSummary {
  __typename: "Wellhead";
  id: string;
  stages: number | null;
  stageTime: number | null;
  totalBoxes: number | null;
  wellName: string | null;
  proppants: (GetFullJobProfile_getJobProfile_pumpScheduleSummary_proppants | null)[] | null;
}

export interface GetFullJobProfile_getJobProfile {
  __typename: "JobProfile";
  totalBoxesForWells: number | null;
  customerDetails: GetFullJobProfile_getJobProfile_customerDetails | null;
  jobDetails: GetFullJobProfile_getJobProfile_jobDetails | null;
  pumpScheduleSummary: (GetFullJobProfile_getJobProfile_pumpScheduleSummary | null)[] | null;
}

export interface GetFullJobProfile {
  getJobProfile: GetFullJobProfile_getJobProfile | null;
}

export interface GetFullJobProfileVariables {
  jobId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetJobProfileSummary
// ====================================================

export interface GetJobProfileSummary_getJobProfileSummary {
  __typename: "JobProfileSummary";
  totalBoxesRemaining: number | null;
  totalBoxesLoaded: number | null;
  averageLoadPerBox: number | null;
}

export interface GetJobProfileSummary {
  getJobProfileSummary: GetJobProfileSummary_getJobProfileSummary | null;
}

export interface GetJobProfileSummaryVariables {
  jobId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetJobSummaryInfo
// ====================================================

export interface GetJobSummaryInfo_getJobSummaryInfo {
  __typename: "JobSummaryInfo";
  jobSummaryId: number | null;
  jobId: number | null;
  proppantId: number | null;
  proppantName: string;
  jobName: string;
  lofaId: number | null;
  sandPo: string;
  transportationPo: string
  lofaName: string;
}

export interface GetJobSummaryInfo {
  getJobSummaryInfo: (GetJobSummaryInfo_getJobSummaryInfo | null)[] | null;
}

export interface GetJobSummaryInfoVariables {
  jobId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLoadAccessorial
// ====================================================

export interface GetLoadAccessorial_getLoadAccessorial {
  __typename: "LoadAccessorialType";
  id: number | null;
  accessorialId: number | null;
  accessorialName: string | null;
  value: string | null;
  checked: string | null;
}

export interface GetLoadAccessorial {
  getLoadAccessorial: (GetLoadAccessorial_getLoadAccessorial | null)[] | null;
}

export interface GetLoadAccessorialVariables {
  input?: LoadAcessorialInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLoadAllocation
// ====================================================

export interface GetLoadAllocation_getLoadAllocation {
  __typename: "AllocationDetails";
  jobName: string;
  lofaId: number;
  lofaName: string;
  proppantId: number;
  proppantName: string;
  sandPO: string;
  transportationPO: string;
  type: string;
  weightonDate1: number | null;
  weightonDate2: number | null;
  weightonDate3: number | null;
  weightonDate4: number | null;
  weightonDate5: number | null;
  weightonDate6: number | null;
  weightonDate7: number | null;
  weightonDate8: number | null;
  weightonDate9: number | null;
  weightonDate10: number | null;
  weightonDate11: number | null;
  weightonDate12: number | null;
  weightonDate13: number | null;
  weightonDate14: number | null;
}

export interface GetLoadAllocation {
  getLoadAllocation: (GetLoadAllocation_getLoadAllocation | null)[] | null;
}

export interface GetLoadAllocationVariables {
  input?: GetLoadAllocationInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLoadAllocationSummary
// ====================================================

export interface GetLoadAllocationSummary_getLoadAllocationSummary {
  __typename: "AllocationSummary";
  id: number | null;
  proppantName: string | null;
  lofaName: string | null;
  sandPO: string | null;
  transportationPO: string | null;
  loadDate: string | null;
  plannedWeight: number | null;
  actualWeight: number | null;
  dispatchedWeight: number | null;
  remainingWeight: number | null;
  lofaId: number | null;
  proppantId: number | null;
  regionId: number | null;
  createdLoads: number | null;
}

export interface GetLoadAllocationSummary {
  getLoadAllocationSummary: (GetLoadAllocationSummary_getLoadAllocationSummary | null)[] | null;
}

export interface GetLoadAllocationSummaryVariables {
  input?: GetLoadAllocationSummaryInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLoadDetail
// ====================================================

export interface GetLoadDetail_getLoadDetail {
  __typename: "LoadDetail";
  boxNumber: string;
  carrierName: string | null;
  driverName: string | null;
  jobSummaryId: number;
  jobName: string | null;
  loadId: number;
  loadingFacility: string | null;
  loadNumber: number;
  lofaId: number;
  truckNumber: string;
  chassisNumber: string;
  transportationPo: string;
  weight: number | null;
  sandPO: string;
  status: string;
  customerName: string;
  jdeNumber: string | null;
  secondaryDriverId: number | null;
  secondaryDriverName: string | null;
  secondaryCarrierName: string | null;
  secondaryTruckNumber: string | null;
  secondaryChassisNumber: string | null;
  regionId: number | null;
  proppantName: string | null;
  isSplit: boolean | null;
  secondaryDriverLoadStatus: string | null;
  tmsId: string | null;
  driverLoadStatus: string | null;
  driverId: number | null;
  customerId: number;
  jobId: number | null;
  loadJobId: number | null;
  boxId: number | null;
  chassisId: number | null;
  secondaryChassisId: number | null;
  proppantId: number | null;
  isBellyDump: boolean | null;
}

export interface GetLoadDetail {
  getLoadDetail: GetLoadDetail_getLoadDetail | null;
}

export interface GetLoadDetailVariables {
  loadId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLoadIdAndSandPo
// ====================================================

export interface GetLoadIdAndSandPo_getLoadIdAndSandPo {
  __typename: "LoadIdSandPoResponse";
  loadId: number | null;
  sandPO: string | null;
}

export interface GetLoadIdAndSandPo {
  getLoadIdAndSandPo: GetLoadIdAndSandPo_getLoadIdAndSandPo | null;
}

export interface GetLoadIdAndSandPoVariables {
  input?: GetLoadIdAndSandPoInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLoadIdByDriverId
// ====================================================

export interface GetLoadIdByDriverId_getLoadIdByDriverId {
  __typename: "DriverCurrentLoadId";
  loadId: number | null;
}

export interface GetLoadIdByDriverId {
  getLoadIdByDriverId: GetLoadIdByDriverId_getLoadIdByDriverId;
}

export interface GetLoadIdByDriverIdVariables {
  driverId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLoadInfo
// ====================================================

export interface GetLoadInfo_getLoadInfo {
  __typename: "LoadInfo";
  loadId: number | null;
  jobSummaryId: number | null;
  weight: number | null;
}

export interface GetLoadInfo {
  getLoadInfo: GetLoadInfo_getLoadInfo | null;
}

export interface GetLoadInfoVariables {
  input?: GetLoadInfoInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLoadList
// ====================================================

export interface GetLoadList_getLoadListByJobId {
  __typename: "LoadManagement";
  atLofaIn: string;
  atLofaOut: string;
  atDestinationIn: string;
  atDestinationOut: string;
  truckNumber: string;
  chassisNumber: string;
  sandTicket: string;
  transportationPo: string;
  jobSummaryId: number;
  loadId: number;
  boxNumber: string | null;
  carrierName: string | null;
  driverCompanyId: number | null;
  driverId: number | null;
  driverName: string | null;
  driverLoadStatus: string | null;
  loadingFacility: string;
  loadNumber: number;
  lofaId: number;
  proppantName: string;
  proppantId: number;
  sandPO: string;
  status: string;
  weight: number;
  regionId: number;
  isSplit: boolean | null;
  secondaryDriverId: number | null;
  secondaryDriverLoadStatus: string | null;
  jobName: string;
  rejectReason: string | null;
  assignedDateTime: string | null;
  rejectedDateTime: string | null;
  userName: string | null;
  rejectedDriverName: string | null;
}

export interface GetLoadList {
  getLoadListByJobId: (GetLoadList_getLoadListByJobId | null)[] | null;
}

export interface GetLoadListVariables {
  input?: GetLoadsInput | null;
  offset?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLoadListCSV
// ====================================================

export interface GetLoadListCSV_getLoadListCSV {
  __typename: "LoadManagementCSV";
  csv: string | null;
}

export interface GetLoadListCSV {
  getLoadListCSV: GetLoadListCSV_getLoadListCSV | null;
}

export interface GetLoadListCSVVariables {
  input?: GetLoadsCSVInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLoadLoggers
// ====================================================

export interface GetLoadLoggers_getLoadLoggers {
  __typename: "Logger";
  id: number;
  message: string;
  creationDate: string;
  createdBy: number | null;
  creatorName: string | null;
  loadId: number;
  systemType: string | null;
}

export interface GetLoadLoggers {
  getLoadLoggers: (GetLoadLoggers_getLoadLoggers | null)[] | null;
}

export interface GetLoadLoggersVariables {
  input?: LoggerSearchInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLoadNotes
// ====================================================

export interface GetLoadNotes_getLoadNotes {
  __typename: "LoadNotesUserDetails";
  id: number | null;
  notes: string | null;
  createdAt: string | null;
  modifiedAt: string | null;
  createdUserId: number | null;
  loadId: number | null;
  isDeleted: boolean | null;
  name: string | null;
  userName: string | null;
  email: string | null;
}

export interface GetLoadNotes {
  getLoadNotes: (GetLoadNotes_getLoadNotes | null)[] | null;
}

export interface GetLoadNotesVariables {
  loadId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLoadProgress
// ====================================================

export interface GetLoadProgress_getLoadProgress {
  __typename: "LoadProgress";
  isAssigned: boolean;
  assignedDateTime: string | null;
  acceptedDateTime: string | null;
  isLoading: boolean;
  loadingDateTime: string | null;
  isLoaded: boolean;
  loadedDateTime: string | null;
  loadingElapsedTime: string | null;
  milesToWell: number | null;
  isOnSite: boolean;
  onSiteDateTime: string | null;
  isDelivered: boolean;
  deliveredDateTime: string | null;
  deliveryElapsedTime: string | null;
  sandTicketNumber: string | null;
  bolNumber: string | null;
  additionalTicketNumber: string | null;
  weight: number | null;
  grossWeight: number | null;
  tareWeight: number | null;
  sandTicketImage: string | null;
  bolTicketImage: string | null;
  additionalTicketImage: string | null;
  sandTicketUploadedBy: string | null;
  bolTicketUploadedBy: string | null;
  additionalTicketUploadedBy: string | null;
  sandTicketUploadedAt: string | null;
  bolTicketUploadedAt: string | null;
  additionalTicketUploadedAt: string | null;
  emptyBox1: string | null;
  emptyBox2: string | null;
  signerName: string | null;
}

export interface GetLoadProgress {
  getLoadProgress: GetLoadProgress_getLoadProgress | null;
}

export interface GetLoadProgressVariables {
  loadId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLoadSummary
// ====================================================

export interface GetLoadSummary_getLoadSummary_loadSummaries {
  __typename: "LoadSummaryDetails";
  isActive: boolean | null;
  jobSummaryId: number | null;
  lofaId: number | null;
  lofaName: string | null;
  sandPo: string | null;
  transportationPo: string | null;
  loadsCreated: number | null;
  loadsInProgress: number | null;
  loadsCompleted: number | null;
  loadsRemaining: number | null;
  loadsTotal: number | null;
  loadsCompletedVolume: number | null;
  loadsCreatedVolume: number | null;
  loadsInProgressVolume: number | null;
  loadsRemainingVolume: number | null;
  loadsTotalVolume: number | null;
  totalVolume: number | null;
  lofaVolume: number | null;
  volumePerBox: number | null;
  proppantId: number | null;
  milesFromWell: number | null;
}

export interface GetLoadSummary_getLoadSummary {
  __typename: "LoadSummaryByProppant";
  proppantId: number | null;
  proppantName: string | null;
  loadSummaries: (GetLoadSummary_getLoadSummary_loadSummaries | null)[] | null;
}

export interface GetLoadSummary {
  getLoadSummary: (GetLoadSummary_getLoadSummary | null)[] | null;
}

export interface GetLoadSummaryVariables {
  jobId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLocationInfo
// ====================================================

export interface GetLocationInfo_getLocationInfo {
  __typename: "GetLocationInfoResponse";
  originId: number | null;
  originType: string | null;
  originRegionId: number | null;
  originRegionDescrip: string | null;
  originDistrictId: number | null;
  originDistrictDescrip: string | null;
  destinationId: number | null;
  destinationType: string | null;
  destinationRegionId: number | null;
  destinationRegionDescrip: string | null;
  destinationDistrictId: number | null;
  destinationDistrictDescrip: string | null;
}

export interface GetLocationInfo {
  getLocationInfo: GetLocationInfo_getLocationInfo | null;
}

export interface GetLocationInfoVariables {
  input?: GetLocationInfoInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLofaSchedule
// ====================================================

export interface GetLofaSchedule_getLofaSchedule_jobSummaries {
  __typename: "LoadFacilityDetail";
  id: string | null;
  jobSummaryId: number | null;
  lofaName: string | null;
  lofaId: number | null;
  lofaVolume: number | null;
  volumePerBox: number | null;
  proppantId: number | null;
  totalVolume: number | null;
  milesFromWell: number | null;
  sandPo: string | null;
  transportationPo: string | null;
}

export interface GetLofaSchedule_getLofaSchedule {
  __typename: "LofaDetailByProppant";
  proppantId: number | null;
  proppantName: string | null;
  jobSummaries: (GetLofaSchedule_getLofaSchedule_jobSummaries | null)[] | null;
}

export interface GetLofaSchedule {
  getLofaSchedule: (GetLofaSchedule_getLofaSchedule | null)[] | null;
}

export interface GetLofaScheduleVariables {
  jobId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMapActiveData
// ====================================================

export interface GetMapActiveData_getMapActiveData_maps {
  __typename: "mapActiveLoads";
  wellName: string | null;
  loadId: number | null;
  wellLat: number | null;
  wellLong: number | null;
  lofaLat: number | null;
  lofaLong: number | null;
  loadStatus: string | null;
  regionName: string | null;
  milesFromWell: number | null;
  jobId: number | null;
  driverLat: number | null;
  driverLong: number | null;
  lofaName: string | null;
  proppantName: string | null;
  driverName: string | null;
  companyName: string | null;
  lofaId: number | null;
  driverId: number | null;
  driverLastUpdated: string | null;
  averageLoadTime: number | null;
  regionId: number | null;
  carrierId: number | null;
  proppantId: number | null;
  averageUnloadTime: number | null;
  cellPhone: string | null;
  customerId: number | null;
  atLofaIn: string | null;
  atLofaOut: string | null;
  avgDriveTimeLofaToWell: number | null;
  driveTimeToWellSoFar: number | null;
}

export interface GetMapActiveData_getMapActiveData_onshiftdrivers {
  __typename: "onShiftDrivers";
  driverId: number | null;
  driverName: string | null;
  companyName: string | null;
  cellPhone: string | null;
  driverLat: number | null;
  driverLong: number | null;
  driverLastUpdated: string | null;
  carrierId: number | null;
}

export interface GetMapActiveData_getMapActiveData {
  __typename: "ActiveMapData";
  maps: (GetMapActiveData_getMapActiveData_maps | null)[] | null;
  onshiftdrivers: (GetMapActiveData_getMapActiveData_onshiftdrivers | null)[] | null;
}

export interface GetMapActiveData {
  getMapActiveData: GetMapActiveData_getMapActiveData | null;
}

export interface GetMapActiveDataVariables {
  jobId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMaxStage
// ====================================================

export interface GetMaxStage_getMaxStage {
  __typename: "Count";
  count: number;
}

export interface GetMaxStage {
  getMaxStage: GetMaxStage_getMaxStage;
}

export interface GetMaxStageVariables {
  jobId?: number | null;
  wellHead?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMobDemobFormExportDownload
// ====================================================

export interface GetMobDemobFormExportDownload_getMobDemobFormExportDownload {
  __typename: "AssetLoadManagement";
  loadId: number | null;
  carrierName: string | null;
  driverName: string | null;
  origin: string | null;
  destination: string | null;
  trailerType: string | null;
  status: string | null;
  assetLoadType: string | null;
  atOriginIn: string | null;
  atOriginOut: string | null;
  atDestinationIn: string | null;
  atDestinationOut: string | null;
  equipments: string | null;
  mobId: number | null;
  truckNumber: string | null;
  payCode: string | null;
  miles: number | null;
  accessorialCost: number | null;
  originAddress: string | null;
  destinationAddress: string | null;
  customer: string | null;
  jobName: string | null;
  region: string | null;
  district: string | null;
  districtAbbreviation: string | null;
  kronosId: string | null;
  comments: string | null;
  quantity: number | null;
}

export interface GetMobDemobFormExportDownload {
  getMobDemobFormExportDownload: (GetMobDemobFormExportDownload_getMobDemobFormExportDownload | null)[] | null;
}

export interface GetMobDemobFormExportDownloadVariables {
  input?: GetFilteredAssetLoadListForDownloadInput | null;
  offset?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMobDetails
// ====================================================

export interface GetMobDetails_getMobDetails_stats {
  __typename: "MobDetailsStat";
  assetTypeId: number | null;
  assetType: string | null;
  plannedQty: number | null;
  availableQty: number | null;
  created: number | null;
  readyForDispatch: number | null;
  inRoute: number | null;
  delivered: number | null;
  actualQty: number | null;
  additionalNeeded: number | null;
}

export interface GetMobDetails_getMobDetails_jobInfo {
  __typename: "MobDetailsJobInfo";
  mobStatus: string | null;
  mobDate: string | null;
  mobEndDate: string | null;
  leapFrog: boolean | null;
}

export interface GetMobDetails_getMobDetails {
  __typename: "GetMobDetailsResponse";
  stats: (GetMobDetails_getMobDetails_stats | null)[] | null;
  jobInfo: GetMobDetails_getMobDetails_jobInfo | null;
}

export interface GetMobDetails {
  getMobDetails: GetMobDetails_getMobDetails | null;
}

export interface GetMobDetailsVariables {
  input?: GetMobDetailsInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPartials
// ====================================================

export interface GetPartials_getPartials {
  __typename: "GetPartialsRespose";
  stageSheetBoxId: number | null;
  proppantId: number | null;
  boxId: number | null;
  boxDesc: string | null;
  loadWeight: number | null;
  splitWeight: number | null;
  stageSheetId: number | null;
  unAllocatedWeight: number | null;
}

export interface GetPartials {
  getPartials: (GetPartials_getPartials | null)[] | null;
}

export interface GetPartialsVariables {
  boxDesc?: number | null;
  stageSheetBoxId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPdf
// ====================================================

export interface GetPdf_getPdf {
  __typename: "PdfResponse";
  sandTicketExtract: string | null;
}

export interface GetPdf {
  getPdf: GetPdf_getPdf | null;
}

export interface GetPdfVariables {
  stageSheetId?: number | null;
  operation?: string | null;
  jobId?: number | null;
  key?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetRolePermissions
// ====================================================

export interface GetRolePermissions_getPermissionRoles_categories_permissions_assignments {
  __typename: "PermissionAssignment";
  roleId: number;
  isAssigned: boolean;
}

export interface GetRolePermissions_getPermissionRoles_categories_permissions {
  __typename: "PermissionRole";
  id: number;
  name: string;
  assignments: GetRolePermissions_getPermissionRoles_categories_permissions_assignments[];
}

export interface GetRolePermissions_getPermissionRoles_categories {
  __typename: "PermissionCategory";
  name: string;
  permissions: GetRolePermissions_getPermissionRoles_categories_permissions[];
}

export interface GetRolePermissions_getPermissionRoles_headers {
  __typename: "PermissionHeader";
  id: number;
  name: string;
}

export interface GetRolePermissions_getPermissionRoles {
  __typename: "PermissionRoles";
  categories: GetRolePermissions_getPermissionRoles_categories[];
  headers: GetRolePermissions_getPermissionRoles_headers[];
}

export interface GetRolePermissions {
  getPermissionRoles: GetRolePermissions_getPermissionRoles;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetRecipientDetails
// ====================================================

export interface GetRecipientDetails_getRecipientDetails_recipientDetails {
  __typename: "RecipientDetails";
  id: number;
  userId: number;
  name: string;
  alertType: string;
  isExternal: boolean;
  email: string;
}

export interface GetRecipientDetails_getRecipientDetails {
  __typename: "RecipientDetailsListResponse";
  recipientDetails: (GetRecipientDetails_getRecipientDetails_recipientDetails | null)[] | null;
  regionEmail: string | null;
}

export interface GetRecipientDetails {
  getRecipientDetails: GetRecipientDetails_getRecipientDetails | null;
}

export interface GetRecipientDetailsVariables {
  jobId?: number | null;
  notificationType?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetRoles
// ====================================================

export interface GetRoles_getRoles {
  __typename: "Role";
  id: number | null;
  name: string | null;
  displayName: string | null;
}

export interface GetRoles {
  getRoles: (GetRoles_getRoles | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSelectedDriversForJob
// ====================================================

export interface GetSelectedDriversForJob_getSelectedDriversForJob {
  __typename: "DriversForJobPool";
  id: number | null;
  driverId: number;
  name: string;
  companyName: string | null;
  jobName: string | null;
  notes: string | null;
}

export interface GetSelectedDriversForJob {
  getSelectedDriversForJob: (GetSelectedDriversForJob_getSelectedDriversForJob | null)[] | null;
}

export interface GetSelectedDriversForJobVariables {
  jobId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSettingByName
// ====================================================

export interface GetSettingByName_getSettingByName {
  __typename: "Setting";
  id: number | null;
  name: string | null;
  value: string | null;
}

export interface GetSettingByName {
  getSettingByName: GetSettingByName_getSettingByName | null;
}

export interface GetSettingByNameVariables {
  name?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSetup
// ====================================================

export interface GetSetup_getSetup_rowDetails {
  __typename: "GetSetupRowColumnProps";
  id: number | null;
  descrip: string | null;
}

export interface GetSetup_getSetup_columnDetails {
  __typename: "GetSetupRowColumnProps";
  id: number | null;
  descrip: string | null;
}

export interface GetSetup_getSetup {
  __typename: "GetSetupResponse";
  rowCount: number | null;
  columnCount: number | null;
  rowDetails: (GetSetup_getSetup_rowDetails | null)[] | null;
  columnDetails: (GetSetup_getSetup_columnDetails | null)[] | null;
}

export interface GetSetup {
  getSetup: GetSetup_getSetup | null;
}

export interface GetSetupVariables {
  jobId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetStageDetails
// ====================================================

export interface GetStageDetails_getStageDetails_stageDetails {
  __typename: "StageDetails";
  stageGroupId: number | null;
  stageSheetId: number | null;
  jobStageId: number | null;
  stage: number | null;
  overallStage: number | null;
  startDate: string | null;
  endDate: string | null;
  wellhead: string | null;
  status: string | null;
  comments: string | null;
  fracType: string | null;
}

export interface GetStageDetails_getStageDetails {
  __typename: "StageDetailsResponse";
  isLastItem: boolean | null;
  isPagingRequired: boolean | null;
  wellName: string | null;
  jobStatus: string | null;
  stageDetails: (GetStageDetails_getStageDetails_stageDetails | null)[] | null;
  isBellyDump: boolean | null;
}

export interface GetStageDetails {
  getStageDetails: GetStageDetails_getStageDetails | null;
}

export interface GetStageDetailsVariables {
  input?: GetStageDetailsInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetStageInfo
// ====================================================

export interface GetStageInfo_getStageInfo {
  __typename: "GetStageInfoInputResponse";
  index: number | null;
  stageSheetId: number | null;
  stageDesc: string | null;
  stageSheetColor: string | null;
}

export interface GetStageInfo {
  getStageInfo: (GetStageInfo_getStageInfo | null)[] | null;
}

export interface GetStageInfoVariables {
  input?: GetStageInfoInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetStages
// ====================================================

export interface GetStages_getStages {
  __typename: "GetStagesResponse";
  jobStageId: number | null;
  stage: number | null;
  overallStage: number | null;
  wellhead: string | null;
  status: string | null;
}

export interface GetStages {
  getStages: (GetStages_getStages | null)[] | null;
}

export interface GetStagesVariables {
  input?: GetStagesInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetStagesByJobId
// ====================================================

export interface GetStagesByJobId_getStagesByJobId {
  __typename: "StageWellheads";
  jobStageId: number;
  stage: number;
  status: string;
  wellhead: string;
  overallStage: number;
}

export interface GetStagesByJobId {
  getStagesByJobId: (GetStagesByJobId_getStagesByJobId | null)[] | null;
}

export interface GetStagesByJobIdVariables {
  jobId?: number | null;
  proppantId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetStagesForJobLog
// ====================================================

export interface GetStagesForJobLog_getStagesForJobLog {
  __typename: "GetStagesForJobLogResponse";
  index: number | null;
  stageIds: string | null;
  stageDesc: string | null;
}

export interface GetStagesForJobLog {
  getStagesForJobLog: (GetStagesForJobLog_getStagesForJobLog | null)[] | null;
}

export interface GetStagesForJobLogVariables {
  jobId?: number | null;
  isGrouped?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetStageSheet
// ====================================================

export interface GetStageSheet_getStageSheet_propDetails {
  __typename: "ProppantDetailsProps";
  stageSheetProppantId: number | null;
  proppantName: string | null;
  totalWeightNeeded: number | null;
  sandPumped: number | null;
  totalBoxWeight: number | null;
}

export interface GetStageSheet_getStageSheet_details {
  __typename: "StageSheetDetailsProps";
  stageSheetProppantId: number | null;
  stageSheetBoxId: number | null;
  station: string | null;
  runOrder: number | null;
  boxDesc: string | null;
  boxWeight: number | null;
  boxWeightRemaining: number | null;
  isOOS: boolean | null;
  proppantId: number | null;
  proppant: string | null;
  location: string | null;
  sandPo: string | null;
  sandTicket: string | null;
  loadId: number | null;
  sandTicketLink: string | null;
  accumulatedWeight: number | null;
  currentProppantWeight: number | null;
  isPartial: string | null;
  loadWeight: number | null;
  boxId: number | null;
  isCompleted: boolean | null;
  lofaOrigin: string | null;
  stageSheetBellyDump: (StageSheetBellyDump | null)[] | null;
}

export interface StageSheetBellyDump {
  id: number | null;
  boxId: number | null;
  stageSheetBoxId: number | null;
  stageSheetProppantId: number | null;
  sandTicket: string | null;
  isLoadCompleted: boolean | null;
  isPartial: boolean | null;
  sandTicketWeight: number | null;
  sandTicketWeightRemaining: number | null;
  lastUpdatedDateTimeSBS: string | null;
  sBSLastUpdatedBy : string | null;
  loadId: number | null;
  sandTicketLink: string | null;
  allocatedWt: number | null;
  remainingWt: number | null;
}

export interface GetStageSheet_getStageSheet {
  __typename: "StageSheetDetails";
  propDetails: (GetStageSheet_getStageSheet_propDetails | null)[] | null;
  details: (GetStageSheet_getStageSheet_details | null)[] | null;
}

export interface GetStageSheet {
  getStageSheet: GetStageSheet_getStageSheet | null;
}

export interface GetStageSheetVariables {
  stageSheetId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetStageSheetProp
// ====================================================

export interface GetStageSheetProp_getStageSheetProp {
  __typename: "GetStageSheetPropResponse";
  stageSheetProppantId: number | null;
  proppantName: string | null;
  totalWeightNeeded: number | null;
  sandPumped: number | null;
  totalBoxWeight: number | null;
  proppantId: number | null;
}

export interface GetStageSheetProp {
  getStageSheetProp: (GetStageSheetProp_getStageSheetProp | null)[] | null;
}

export interface GetStageSheetPropVariables {
  stageSheetId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetStageSummary
// ====================================================

export interface GetStageSummary_getStageSummary {
  __typename: "JobStageSummary";
  wellhead: string;
  preparing: number;
  running: number;
  paused: number;
  completed: number;
  remaining: number;
}

export interface GetStageSummary {
  getStageSummary: (GetStageSummary_getStageSummary | null)[] | null;
}

export interface GetStageSummaryVariables {
  jobId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetStandbyDrivers
// ====================================================

export interface GetStandbyDrivers_getStandbyDrivers {
  __typename: "StandByDriversResponse";
  driverId: number | null;
  driverName: string | null;
  carrierName: string | null;
  driverPoolNotes: string | null;
  loadRequested: number | null;
  loadRejected: number | null;
  loadDelivered: number | null;
  onShift: number | null;
  assignedTime: string | null;
  checkInWithBellyDump: boolean | null;
}

export interface GetStandbyDrivers {
  getStandbyDrivers: (GetStandbyDrivers_getStandbyDrivers | null)[] | null;
}

export interface GetStandbyDriversVariables {
  input?: StandByDriverInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetTmsDuplicates
// ====================================================

export interface GetTmsDuplicates_getTmsDuplicates {
  __typename: "TmsDuplicateCheckResponse";
  duplicateTmsIds: (number | null)[] | null;
}

export interface GetTmsDuplicates {
  getTmsDuplicates: GetTmsDuplicates_getTmsDuplicates | null;
}

export interface GetTmsDuplicatesVariables {
  input?: TmsDuplicateCheckInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetTonnageExtract
// ====================================================

export interface GetTonnageExtract_getTonnageExtract {
  __typename: "TonnageDetails";
  id: number | null;
  lofaId: number | null;
  lofaName: string | null;
  proppantId: number | null;
  proppantName: string | null;
  sandPO: string | null;
  loadDate: string | null;
  plannedWeight: number | null;
  actualWeight: number | null;
  updatedBy: string | null;
  updatedDate: string | null;
}

export interface GetTonnageExtract {
  getTonnageExtract: (GetTonnageExtract_getTonnageExtract | null)[] | null;
}

export interface GetTonnageExtractVariables {
  input?: GetLoadAllocationInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUserFiltered
// ====================================================

export interface GetUserFiltered_getUserFiltered {
  __typename: "User";
  id: number | null;
  name: string | null;
  emailAddress: string | null;
  roleId: number | null;
  isActive: boolean | null;
  status: string | null;
}

export interface GetUserFiltered {
  getUserFiltered: (GetUserFiltered_getUserFiltered | null)[] | null;
}

export interface GetUserFilteredVariables {
  input?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUserRegionDistrictByUserId
// ====================================================

export interface GetUserRegionDistrictByUserId_getUserRegionDistrictByUserId {
  __typename: "UserRegionDistrict";
  districtIds: string;
  regionIds: string;
}

export interface GetUserRegionDistrictByUserId {
  getUserRegionDistrictByUserId: GetUserRegionDistrictByUserId_getUserRegionDistrictByUserId | null;
}

export interface GetUserRegionDistrictByUserIdVariables {
  userId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUsers
// ====================================================

export interface GetUsers_getUsers {
  __typename: "User";
  id: number | null;
  name: string | null;
  emailAddress: string | null;
  roleId: number | null;
  isActive: boolean | null;
}

export interface GetUsers {
  getUsers: (GetUsers_getUsers | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUsersAudit
// ====================================================

export interface GetUsersAudit_getUsersAudit_valuesBefore {
  __typename: "UserAuditModel";
  name: string | null;
  emailAddress: string | null;
  isActive: boolean | null;
  isDeleted: boolean | null;
  roleId: number | null;
}

export interface GetUsersAudit_getUsersAudit_valuesAfter {
  __typename: "UserAuditModel";
  name: string | null;
  emailAddress: string | null;
  isActive: boolean | null;
  isDeleted: boolean | null;
  roleId: number | null;
}

export interface GetUsersAudit_getUsersAudit {
  __typename: "UserAudit";
  id: number;
  userId: number | null;
  auditDate: string | null;
  auditUserName: string | null;
  valuesBefore: GetUsersAudit_getUsersAudit_valuesBefore | null;
  valuesAfter: GetUsersAudit_getUsersAudit_valuesAfter | null;
}

export interface GetUsersAudit {
  getUsersAudit: (GetUsersAudit_getUsersAudit | null)[] | null;
}

export interface GetUsersAuditVariables {
  userId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUsersCheckEmail
// ====================================================

export interface GetUsersCheckEmail_getUsersCheckEmail {
  __typename: "CheckEmailResponse";
  emailExists: boolean | null;
}

export interface GetUsersCheckEmail {
  getUsersCheckEmail: GetUsersCheckEmail_getUsersCheckEmail | null;
}

export interface GetUsersCheckEmailVariables {
  input?: CheckEmailInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetVosUploadImages
// ====================================================

export interface GetVosUploadImages_getVosUploadImages {
  __typename: "GetVosUploadImageInputResponse";
  id: number | null;
  week: string | null;
  startDate: string | null;
  endDate: string | null;
  imageName: string | null;
  uploadedBy: string | null;
  uploadDate: string;
  downloadLink: string | null;
}

export interface GetVosUploadImages {
  getVosUploadImages: (GetVosUploadImages_getVosUploadImages | null)[] | null;
}

export interface GetVosUploadImagesVariables {
  input?: GetVosUploadsInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetVosUploadsByWeek
// ====================================================

export interface GetVosUploadsByWeek_getVosUploadsByWeek {
  __typename: "GetVosUploadsByWeekInputResponse";
  id: number | null;
  name: string | null;
}

export interface GetVosUploadsByWeek {
  getVosUploadsByWeek: (GetVosUploadsByWeek_getVosUploadsByWeek | null)[] | null;
}

export interface GetVosUploadsByWeekVariables {
  input?: GetVosUploadsByWeekInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetWellheadsByJobId
// ====================================================

export interface GetWellheadsByJobId_getWellheadsByJobId {
  __typename: "Wellheads";
  wellHead: string | null;
  stages: number | null;
}

export interface GetWellheadsByJobId {
  getWellheadsByJobId: (GetWellheadsByJobId_getWellheadsByJobId | null)[] | null;
}

export interface GetWellheadsByJobIdVariables {
  jobId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetWellheadsByStageGroupId
// ====================================================

export interface GetWellheadsByStageGroupId_getWellheadsByStageGroupId {
  __typename: "StageWellheads";
  jobStageId: number;
  stage: number;
  overallStage: number;
  wellhead: string;
  status: string;
  stageSheetId: number;
  stageSheetDescrip: string;
  fracType: string;
}

export interface GetWellheadsByStageGroupId {
  getWellheadsByStageGroupId: (GetWellheadsByStageGroupId_getWellheadsByStageGroupId | null)[] | null;
}

export interface GetWellheadsByStageGroupIdVariables {
  stageGroupId?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetYardTypes
// ====================================================

export interface GetYardTypes_getYardTypes {
  __typename: "YardTypes";
  id: number | null;
  descrip: string | null;
}

export interface GetYardTypes {
  getYardTypes: (GetYardTypes_getYardTypes | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum SortOrder {
  ASCENDING = "ASCENDING",
  DESCENDING = "DESCENDING",
}

export enum Status {
  CLOSED = "CLOSED",
  COMPLETE = "COMPLETE",
  CREATED = "CREATED",
  INPROGRESS = "INPROGRESS",
  UNKNOWN = "UNKNOWN",
}

export interface ActivitySummaryInput {
  jobId?: number | null;
  carrierIds?: (number | null)[] | null;
  proppantIds?: (number | null)[] | null;
  lofaIds?: (number | null)[] | null;
  status?: (number | null)[] | null;
}

export interface AddAndSaveDriversToPoolRequest {
  jobId?: number | null;
  driverIds?: (number | null)[] | null;
  notes?: string | null;
  action?: string | null;
}

export interface AddAssetLoadNotesInput {
  notes?: string | null;
  loadId?: number | null;
}

export interface AddBoxesInput {
  stageSheetId?: number | null;
  boxDetails?: (BoxDetailsToAddBoxesProps | null)[] | null;
}

export interface AddDriverLoadNotesInput {
  notes?: string | null;
  loadId?: number | null;
  driverId?: number | null;
}

export interface AddEditJobLogsInput {
  jobLogId?: number | null;
  jobLogIssueId?: number | null;
  jobLogTypeId?: number | null;
  jobId?: number | null;
  startDate?: string | null;
  endDate?: string | null;
  estimatedDowntime?: number | null;
  jobStageId?: number | null;
  loadId?: number | null;
  notes?: string | null;
  locationLofa?: string | null;
  amount?: number | null;
  rootCauseId?: number | null;
  correctiveAction?: string | null;
}

export interface AddEquipmentsInput {
  assetType?: string | null;
  assetTypeId?: number | null;
  assetIds?: string | null;
  locationType?: string | null;
  locationId?: number | null;
  location?: string | null;
}

export interface AddJobInput {
  wellName: string;
  customerId: number;
  crewId: number;
  mobDate?: string | null;
  startJobDate?: string | null;
  endJobDate?: string | null;
  regionId: number;
  districtId: number;
  latitude?: number | null;
  longitude?: number | null;
  epCompanyId?: number | null;
  contact?: string | null;
  phoneNumber?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  city: string;
  stateId: number;
  zip?: string | null;
  notes?: string | null;
  directions?: string | null;
  accessorialId?: number | null;
  miles?: string | null;
  wellsiteGeoFenceType?: string | null;
  wellsiteGeoFenceRadius?: number | null;
  wellsitePolygonCoordinates?: (JobLatLng | null)[] | null;
  stagingLatitude?: number | null;
  stagingLongitude?: number | null;
  stagingGeoFenceType?: string | null;
  stagingGeoFenceRadius?: number | null;
  stagingPolygonCoordinates?: (JobLatLng | null)[] | null;
}

export interface AddJobNotesInput {
  notes?: string | null;
  jobId?: number | null;
}

export interface AddLoadNotesInput {
  notes?: string | null;
  loadId?: number | null;
}

export interface AddNewRoleInput {
  name?: string | null;
  displayName?: string | null;
}

export interface AddStagesInput {
  jobId?: number | null;
  fracType?: string | null;
  stageDetails?: (StageDetailsForAddStages | null)[] | null;
}

export interface AllMessageInput {
  searchString?: string | null;
  dateFrom?: string | null;
  dateTo?: string | null;
  filter?: string | null;
  regionIds?: (number | null)[] | null;
  carrierIds?: (number | null)[] | null;
  pageSize?: number | null;
  messageType?: string | null;
  filterByDrivers?: boolean | null;
  filterByGroups?: boolean | null;
  filterByOnLoad?: boolean | null;
  filterByOnShift?: boolean | null;
  filterByWaitOnLoad?: boolean | null;
}

export interface AllocatePartialInput {
  partialBoxDetails?: (partialBox | null)[] | null;
}

export interface AllocateBoxInput {
  allocateBoxDetails?: (allocateBox | null)[] | null;
}

export interface AssetInfoType {
  assetTypeId?: number | null;
  assetType?: string | null;
  quantity?: number | null;
  assetId?: number | null;
  assetDescrip?: string | null;
}

export interface AssetInfoTypeToCreate {
  assetTypeId?: number | null;
  assetId?: number | null;
  quantity?: number | null;
  assetInfo?: string | null;
}

export interface AssetLoadNotesEdit {
  id?: number | null;
  newValues?: AssetLoadNotesInput | null;
}

export interface AssetLoadNotesInput {
  notes?: string | null;
}

export interface AssetLoadProgressType {
  atOriginIn?: string | null;
  atOriginOut?: string | null;
  atDestinationIn?: string | null;
  atDestinationOut?: string | null;
  status?: string | null;
}

export interface AssetLoadType {
  assetLoadTypeId?: number | null;
  originType?: string | null;
  originJobId?: number | null;
  originLofaId?: number | null;
  originYardId?: number | null;
  originLatitude?: number | null;
  originLongitude?: number | null;
  originRegionId?: number | null;
  originDistrictId?: number | null;
  destinationType?: string | null;
  destinationJobId?: number | null;
  destinationLofaId?: number | null;
  destinationYardId?: number | null;
  destinationRegionId?: number | null;
  destinationDistrictId?: number | null;
  destinationLatitude?: number | null;
  destinationLongitude?: number | null;
  trailerId?: number | null;
  trailerTypeId?: number | null;
  truckNumber?: string | null;
  driverId?: number | null;
  miles?: number | null;
  accessorialCost?: number | null;
  payCode?: string | null;
  details?: (AssetInfoType | null)[] | null;
}

export interface AssignDriverAndSaveLoadInput {
  loadId?: number | null;
  driverId?: number | null;
  tmsId?: string | null;
}

export interface AssignDriverAndSaveLoadListEdit {
  assignDriverAndSaveLoad?: (AssignDriverAndSaveLoadInput | null)[] | null;
}

export interface BoxDetailsToAddBoxesProps {
  boxId?: number | null;
  loadId?: number | null;
  proppantId?: number | null;
  weight?: number | null;
  row?: string | null;
  column?: string | null;
  level?: string | null;
}

export interface BoxDetailsToMove {
  boxId?: number | null;
  boxDescrip?: string | null;
  row?: string | null;
  column?: string | null;
  level?: string | null;
  stageSheetProppantId?: string | null;
  doNotUse?: boolean | null;
  semiAllocated?: boolean | null;
}

export interface BoxDetailsToRevert {
  boxId?: number | null;
  loadId: number | null;
  allocatedWeight: number | null;
}


export interface CarrierDeleteRequest {
  id?: number | null;
}

export interface CarrierListInput {
  carrierIds?: (number | null)[] | null;
}

export interface CarrierMasterDataInput {
  searchString?: string | null;
  compliantStatus?: string | null;
}

export interface CellPhoneInput {
  cellPhone?: string | null;
}

export interface CheckEmailInput {
  emailAddress?: string | null;
}

export interface ConfigureInput {
  JobId?: number | null;
  RecipientsDetails?: (RecipientsVM | null)[] | null;
}

export interface ConfigureInventoryInput {
  jobId?: number | null;
  rowCount?: number | null;
  columnCount?: number | null;
}

export interface ConversationByIdInput {
  searchString?: string | null;
  dateFrom?: string | null;
  dateTo?: string | null;
  id?: string | null;
  date?: string | null;
  filter?: string | null;
  pageSize?: number | null;
  messageType?: string | null;
}

export interface ConversationPreviewInput {
  searchString?: string | null;
  dateFrom?: string | null;
  dateTo?: string | null;
  filter?: string | null;
  regionIds?: (number | null)[] | null;
  pageSize?: number | null;
}

export interface CountLoadsByJobProppantInput {
  jobId: number;
  proppantId: number;
}

export interface CountLoadsByJobWellheadInput {
  jobId: number;
  wellhead: string;
}

export interface CountLoadsInput {
  jobSummaryIds: number[];
  statuses: (number | null)[];
}

export interface CreateAssetLoadInput {
  assetLoadTypeId?: number | null;
  originType?: string | null;
  originJobId?: number | null;
  originLofaId?: number | null;
  originYardId?: number | null;
  originLatitude?: number | null;
  originLongitude?: number | null;
  originRegionId?: number | null;
  originDistrictId?: number | null;
  destinationType?: string | null;
  destinationJobId?: number | null;
  destinationLofaId?: number | null;
  destinationYardId?: number | null;
  destinationLatitude?: number | null;
  destinationLongitude?: number | null;
  destinationRegionId?: number | null;
  destinationDistrictId?: number | null;
  driverId?: number | null;
  trailerTypeId?: number | null;
  trailerId?: number | null;
  miles?: number | null;
  truckNumber?: string | null;
  accessorialCost?: number | null;
  payCode?: string | null;
  assetDetails?: (AssetInfoTypeToCreate | null)[] | null;
  notes?: string | null;
  loadCount?: number | null;
}

export interface CreateLoadsInput {
  numberToCreate?: number | null;
  jobSummaryId?: number | null;
  transportationPo?: string | null;
}

export interface CrewDeleteRequest {
  crewId?: number | null;
}

export interface CustomerDeleteRequest {
  id?: number | null;
}

export interface CustomerParentDeleteRequest {
  id?: number | null;
}

export interface DeleteAssetLoadsInput {
  loadIds?: (number | null)[] | null;
}

export interface DeleteDriverLoadNotes {
  id?: number | null;
}

export interface DeleteJobImageRequest {
  id?: number | null;
}

export interface DeleteJobLogInput {
  jobLogId?: number | null;
}

export interface DeleteLoadsInput {
  loadIds?: (number | null)[] | null;
}

export interface DeleteVosUploadRequest {
  id?: number | null;
}

export interface DeleteYardInput {
  id?: number | null;
}

export interface DisableJobInput {
  jobId?: number | null;
}

export interface DistanceDriverDetail {
  driverId?: number | null;
  driverLat?: number | null;
  driverLong?: number | null;
  wellLat?: number | null;
  wellLong?: number | null;
  lofaLat?: number | null;
  lofaLong?: number | null;
  distanceToLofa?: number | null;
  distanceToWellsite?: number | null;
  timeToDestinationInSeconds?: number | null;
  timeToDestinationInMinutes?: number | null;
}

export interface DistanceDriverInput {
  driver?: DistanceDriverDetail | null;
  destination?: string | null;
}

export interface SpillBoxDetailInput {
  boxId?: number | null;
  loadId?: number | null;
  spillWeight?: number | null;
  sandTicketNumber?: string | null;
  ticketWeight?: number | null;
  actualWeight?: number | null;
}

export interface DnuOperateInput {
  jobId?: number | null;
  boxIds?: (number | null)[] | null;
  operation?: string | null;
  spillBoxDetails?: (SpillBoxDetailInput | null)[] | null;
}

export interface DriverActivityInput {
  jobId?: number | null;
  carrierIds?: (number | null)[] | null;
  proppantIds?: (number | null)[] | null;
  lofaIds?: (number | null)[] | null;
  status?: (number | null)[] | null;
}

export interface DriverConversationInput {
  dateTo?: string | null;
  dateFrom?: string | null;
  messageType?: string | null;
  pageSize?: number | null;
  driverId?: number | null;
  searchKeyword?: string | null;
}

export interface DriverDeleteRequest {
  id?: number | null;
}

export interface DriverListInput {
  regionIds?: (number | null)[] | null;
  districtIds?: (number | null)[] | null;
  statuses?: (number | null)[] | null;
  carrierIds?: (number | null)[] | null;
  search?: string | null;
  driverId?: number | null;
  activeStatus?: string | null;
  compliantStatus?: string | null;
  isAvailable?: string | null;
  checkInWithBellyDump?: string | null;
}

export interface DriverLoadNotesEdit {
  id?: number | null;
  newValues?: DriverLoadNotesInput | null;
}

export interface DriverLoadNotesInput {
  notes?: string | null;
}

export interface DriverLoadStatusDeleteRequest {
  id?: number | null;
}

export interface DriverLocationsInput {
  loadId?: number | null;
}

export interface DriverMessageInput {
  regionIds?: (number | null)[] | null;
  searchString?: string | null;
  pageSize?: number | null;
  filterByOnLoad?: boolean | null;
  filterByOnShift?: boolean | null;
  filterByWaitOnLoad?: boolean | null;
  driverId?: number | null;
  carrierIds?: (number | null)[] | null;
}

export interface EditAssetLoadInput {
  assetLoadId?: number | null;
  currentValues?: AssetLoadType | null;
  newValues?: AssetLoadType | null;
}

export interface EditAssetLoadProgressInput {
  loadId?: number | null;
  newValues?: AssetLoadProgressType | null;
  currentValues?: AssetLoadProgressType | null;
}

export interface EditBoxInput {
  boxIds?: string | null;
  loadId?: number | null;
  jobSummaryId?: number | null;
  weight?: number | null;
  action?: string | null;
}

export interface EditLeapFrogInput {
  jobId?: number | null;
  leapFrog?: boolean | null;
}

export interface EditPermissionsToRoleInput {
  roleId?: number | null;
  permissionId?: number | null;
  editTypeId?: boolean | null;
}

export interface EditStageSheetInput {
  weightDetails?: (WeightDetailsType | null)[] | null;
  stageSheetDetails?: (StageSheetDetailsType | null)[] | null;
}

export interface EditStagesInput {
  stageGroupId?: number | null;
  jobId?: number | null;
  fracType?: string | null;
  stageDetails?: (StageDetailsForEditStages | null)[] | null;
}

export interface EndStagesInput {
  stageIds?: (number | null)[] | null;
  comments?: string | null;
  fromStageSheet?: boolean | null;
}

export interface EquipmentInfoType {
  assetTypeId?: number | null;
  plannedQty?: number | null;
}

export interface EquipmentLoggerSearchInput {
  loadId: number;
  search?: string | null;
}

export interface ExportDriverMessageQueryInput {
  driverId?: number | null;
  conversationid?: string | null;
  isDriver?: boolean | null;
  dateFrom?: string | null;
  dateTo?: string | null;
  filter?: string | null;
  isAllconverationExport?: boolean | null;
}

export interface GetAllJobsInput {
  regionIds?: (number | null)[] | null;
  districtIds?: (number | null)[] | null;
  statuses?: (number | null)[] | null;
  customerIds?: (number | null)[] | null;
  searchString?: string | null;
  sortOrder?: SortOrder | null;
}

export interface GetAllLocationsInput {
  locationType?: string | null;
  locationId?: number | null;
}

export interface GetAllTrailersInput {
  trailerTypeId?: number | null;
  assetLoadId?: number | null;
}

export interface GetAllVosUploadsInput {
  year?: number | null;
  monthId?: number | null;
}

export interface GetDemobDetailsInput {
  destinationType?: string | null;
  destinationId?: number | null;
  originId?: number | null;
}

export interface GetDriversByRegionInput {
  regionId?: number | null;
  districtId?: number | null;
}

export interface GetEquipmentsInfoInput {
  originType?: string | null;
  originId?: number | null;
}

export interface GetFilteredAssetLoadListForDownloadInput {
  jobIds?: (number | null)[] | null;
  regionIds?: (number | null)[] | null;
  statuses?: (number | null)[] | null;
  loadTypeIds?: (number | null)[] | null;
  drivers?: (number | null)[] | null;
  carriers?: (number | null)[] | null;
  equipmentId?: string | null;
  equipmentTypeIds?: (number | null)[] | null;
  trailerTypeIds?: (number | null)[] | null;
  atDestinationOutFrom?: string | null;
  atDestinationOutTo?: string | null;
  isSearchOnLoadId?: boolean | null;
  search?: string | null;
  sortOrder?: string | null;
  isKronosExport?: boolean | null;
  isMobFormExport?: number | null;
}

export interface GetFilteredAssetLoadListInput {
  jobIds?: (number | null)[] | null;
  regionIds?: (number | null)[] | null;
  statuses?: (number | null)[] | null;
  loadTypeIds?: (number | null)[] | null;
  drivers?: (number | null)[] | null;
  carriers?: (number | null)[] | null;
  equipmentId?: string | null;
  equipmentTypeIds?: (number | null)[] | null;
  trailerTypeIds?: (number | null)[] | null;
  atDestinationOutFrom?: string | null;
  atDestinationOutTo?: string | null;
  isSearchOnLoadId?: boolean | null;
  search?: string | null;
  sortOrder?: string | null;
}

export interface GetFilteredLoadListInput {
  jobIds?: (number | null)[] | null;
  regionIds?: (number | null)[] | null;
  districtIds?: (number | null)[] | null;
  customerIds?: (number | null)[] | null;
  jobStatuses?: (number | null)[] | null;
  proppants?: (number | null)[] | null;
  statuses?: (number | null)[] | null;
  carriers?: (number | null)[] | null;
  drivers?: (number | null)[] | null;
  lofas?: (number | null)[] | null;
  atDestinationOutFrom?: string | null;
  atDestinationOutTo?: string | null;
  isSearchOnLoadId?: boolean | null;
  search?: string | null;
  sortOrder?: string | null;
}

export interface GetJobLogNotesInput {
  jobLogId?: number | null;
  tzinfo?: string | null;
}

export interface GetJobLogSummaryInput {
  jobId?: number | null;
  fromDate?: string | null;
  toDate?: string | null;
  getdaywisestatsonly?: boolean | null;
  tzinfo?: string | null;
}

export interface GetJobLogsInput {
  jobId?: number | null;
  jobLogTypeId?: number | null;
  jobLogId?: number | null;
  fromDate?: string | null;
  toDate?: string | null;
  pageNum?: number | null;
  tzinfo?: string | null;
  key?: number | null;
}

export interface GetLoadAllocationInput {
  fromDate?: string | null;
  jobId?: number | null;
  toDate?: string | null;
}

export interface GetLoadAllocationSummaryInput {
  date?: string | null;
  jobId?: number | null;
}

export interface GetLoadIdAndSandPoInput {
  proppantId?: number | null;
  lofaId?: number | null;
  jobId?: number | null;
  sandPO?: string | null;
  transportationPO?: string | null;
}

export interface GetLoadInfoInput {
  sandTicket?: string | null;
  loadId?: number | null;
}

export interface GetLoadsCSVInput {
  jobId?: number | null;
  dateRangeFilter?: string | null;
}

export interface GetLoadsInput {
  jobId?: number | null;
  isSearchOnLoadId?: boolean | null;
  search?: string | null;
  statuses?: (number | null)[] | null;
  carriers?: (number | null)[] | null;
  drivers?: (number | null)[] | null;
  lofas?: (number | null)[] | null;
  proppants?: (number | null)[] | null;
  dateRangeFilter?: string | null;
}

export interface GetLocationInfoInput {
  originType?: string | null;
  originId?: number | null;
  destinationType?: string | null;
  destinationId?: number | null;
}

export interface GetMobDetailsInput {
  originType?: string | null;
  originId?: number | null;
  destinationId?: number | null;
}

export interface GetStageDetailsInput {
  jobId?: number | null;
  isCompleted?: boolean | null;
  pageNum?: number | null;
  wellHead?: string | null;
}

export interface GetStageInfoInput {
  jobId?: number | null;
  proppantId?: number | null;
}

export interface GetStagesInput {
  jobId?: number | null;
  proppantId?: number | null;
}

export interface GetVosUploadsByWeekInput {
  year?: number | null;
  monthId?: number | null;
}

export interface GetVosUploadsInput {
  jobId?: number | null;
  year?: number | null;
  monthId?: number | null;
  weekId?: number | null;
}

export interface JobLatLng {
  lat?: number | null;
  lng?: number | null;
}

export interface JobNotesEdit {
  id?: number | null;
  newValues?: JobNotesInput | null;
}

export interface JobNotesInput {
  notes?: string | null;
}

export interface JobProfileEdit {
  jobId: number;
  jobProfileValues?: JobProfileInput | null;
}

export interface JobProfileInput {
  jobNumber?: string | null;
  extSystemIdentifier?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  mobDate?: string | null;
  statusId: number;
  wellName: string;
  regionId: number;
  districtId: number;
  latitude?: number | null;
  longitude?: number | null;
  directions?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  city: string;
  stateId: number;
  zip?: string | null;
  customerId: number;
  crewId: number;
  epCompanyId?: number | null;
  contact?: string | null;
  phoneNumber?: string | null;
  accessorialId?: number | null;
  miles?: string | null;
  wellsiteGeoFenceType?: string | null;
  wellsiteGeoFenceRadius?: number | null;
  wellsitePolygonCoordinates?: (JobLatLng | null)[] | null;
  stagingLatitude?: number | null;
  stagingLongitude?: number | null;
  stagingGeoFenceType?: string | null;
  stagingGeoFenceRadius?: number | null;
  stagingPolygonCoordinates?: (JobLatLng | null)[] | null;
}

export interface LatLng {
  lat?: number | null;
  lng?: number | null;
}

export interface LoadAccessorialsEdit {
  loadId?: number | null;
  newValues?: LoadAccessorialsEditFields | null;
  currentValues?: LoadAccessorialsEditFields | null;
}

export interface LoadAccessorialsEditFields {
  deadHeadValue?: string | null;
  accessorialId?: number | null;
  checked?: string | null;
}

export interface LoadAcessorialInput {
  loadId?: number | null;
  accessorialName?: (string | null)[] | null;
}

export interface LoadDetailEdit {
  loadId?: number | null;
  newValues?: LoadDetailEditFields | null;
  currentValues?: LoadDetailEditFields | null;
}

export interface LoadDetailEditFields {
  driverLoadStatus?: string | null;
  boxNumber?: string | null;
  boxId?: number | null;
  chassisId?: number | null;
  chassisNumber?: string | null;
  truckNumber?: string | null;
  secondaryDriverLoadStatus?: string | null;
  secondaryChassisId?: number | null;
  secondaryChassisNumber?: string | null;
  secondaryTruckNumber?: string | null;
  leanId?: string | null;
  transportationPo?: string | null;
  isBellyDump?: boolean | null;
}

export interface LoadDetailFieldOpEdit {
  loadId: number;
  jobId: number;
  loadDetailFieldOpValues?: LoadDetailFieldOpInput | null;
}

export interface LoadDetailFieldOpInput {
  boxId: number;
  chassisId: number;
  truckNumber: string;
  sandTicketNumber?: string | null;
  grossWeight: number;
  netWeight: number;
  tareWeight: number;
  stageId?: number | null;
  signatureBase64: string;
  emptyBoxNumber1Id?: number | null;
  emptyBoxNumber2Id?: number | null;
  firstName: string;
  lastName: string;
}

export interface LoadFacilityDetailEdit {
  jobSummaryId?: number | null;
  jobId?: number | null;
  lofaId?: number | null;
  lofaName?: string | null;
  totalVolume?: number | null;
  lofaVolume?: number | null;
  volumePerBox?: number | null;
  proppantId?: number | null;
  milesFromWell?: number | null;
  sandPo?: string | null;
  transportationPo?: string | null;
  isDeleted?: boolean | null;
}

export interface LoadNotesEdit {
  id?: number | null;
  newValues?: LoadNotesInput | null;
}

export interface LoadNotesInput {
  notes?: string | null;
}

export interface LoadProgressEdit {
  loadId?: number | null;
  newValues?: LoadProgressEditFields | null;
  currentValues?: LoadProgressEditFields | null;
}

export interface LoadProgressEditFields {
  atLofaIn?: string | null;
  atLofaOut?: string | null;
  atDestinationIn?: string | null;
  atDestinationOut?: string | null;
  boLreceived?: string | null;
  sandTicket?: string | null;
  bol2Received?: string | null;
  weight?: number | null;
  grossWeight?: number | null;
  tareWeight?: number | null;
  miles?: number | null;
  returnBoxNumber1?: string | null;
  returnBoxNumber2?: string | null;
}

export interface LoadStatusEdit {
  loadId?: number | null;
  loadStatusEdit?: LoadStatusEditFields | null;
}

export interface LoadStatusEditFields {
  oldStatus?: string | null;
  newStatus?: string | null;
}

export interface LofaDeleteRequest {
  id?: number | null;
}

export interface LofaDetailByProppantEdit {
  proppantId?: number | null;
  proppantName?: string | null;
  jobSummaries?: (LoadFacilityDetailEdit | null)[] | null;
}

export interface LofaScheduleEdit {
  jobId?: number | null;
  newValues?: (LofaDetailByProppantEdit | null)[] | null;
}

export interface LoggerSearchInput {
  loadId: number;
  search?: string | null;
}

export interface MarkAllConversationReadInput {
  conversationId?: string | null;
}

export interface MarkAllReadInput {
  driverId?: number | null;
}

export interface MessageStatusInput {
  conversationId?: string | null;
  id?: number | null;
  messageId?: number | null;
  markMessageAsUnRead?: boolean | null;
}

export interface MessagesInput {
  conversationName?: string | null;
  bodyMessage?: string | null;
  messageType?: string | null;
  creationDate?: string | null;
}

export interface MoveBoxesInput {
  jobId?: number | null;
  boxDetails?: (BoxDetailsToMove | null)[] | null;
}

export interface RevertBoxesInput {
  jobId?: number | null;
  boxDetails?: (BoxDetailsToRevert | null)[] | null;
}

export interface SpillModalInput {
  boxId?: number | null;
  sandTicket?: number | null;
  loadId?: string | null;
  spillWeight?: number | null;
}

export interface SpillBoxInput {
  jobId?: number | null;
  spillModal?: (SpillModalInput | null)[] | null;
}

export interface NotificationInput {
  regionIds?: (number | null)[] | null;
  searchString?: string | null;
  pageSize?: number | null;
  filterByOnLoad?: boolean | null;
  filterByOnShift?: boolean | null;
  filterByWaitOnLoad?: boolean | null;
  filter?: string | null;
  dateFrom?: string | null;
  dateTo?: string | null;
  driverId?: number | null;
  notificationType?: string | null;
  carrierIds?: (number | null)[] | null;
}

export interface PauseStagesInput {
  stageIds?: (number | null)[] | null;
}

export interface ProppantAddRequest {
  proppantId?: number | null;
  proppantName: string;
  extSystemName?: string | null;
  extSystemReference?: string | null;
  isDeleted?: boolean | null;
}

export interface ProppantDeleteRequest {
  proppantId?: number | null;
}

export interface ProppantEditRequest {
  id?: number | null;
  proppantValues?: ProppantEditRequestValues | null;
}

export interface ProppantEditRequestValues {
  proppantName?: string | null;
  extSystemReference?: string | null;
}

export interface ProppantInput {
  pumpScheduleId?: number | null;
  proppantId?: number | null;
  proppantName?: string | null;
  totalVolume?: number | null;
  volumePerBox?: number | null;
  isDeleted?: boolean | null;
}

export interface PumpScheduleEdit {
  jobId?: number | null;
  newValues?: (WellheadInput | null)[] | null;
}

export interface RecipientsVM {
  userId?: number | null;
  alertType?: string | null;
  userEmail?: string | null;
  isExternal?: boolean | null;
}

export interface RemoveBoxInput {
  stageSheetBoxId?: number | null;
}

export interface RemoveImageFromALoadInput {
  loadId?: number | null;
  removeImageFromLoad?: RemoveImageFromALoadInputDetails | null;
}

export interface RemoveImageFromALoadInputDetails {
  imageName?: string | null;
}

export interface ReplaceImageForALoadInput {
  loadId?: number | null;
  replaceImageForALoad?: ReplaceImageForALoadInputDetails | null;
}

export interface ReplaceImageForALoadInputDetails {
  name?: string | null;
  imageName?: string | null;
  imageData?: string | null;
  isDriver?: boolean | null;
}

export interface ResolveAllDriverLoadNotesInput {
  loadId?: number | null;
}

export interface ResolveDriverLoadNoteInput {
  id?: number | null;
}

export interface ResumeStagesInput {
  stageIds?: (number | null)[] | null;
  jobId?: number | null;
}

export interface RevertStageSheetInput {
  stageSheetDetails?: (StageSheetDetailsToRevert | null)[] | null;
  jobStatus?: string | null;
}

export interface RevertStagesInput {
  stageIds?: (number | null)[] | null;
}

export interface RunOrderDetailsType {
  stageSheetBoxId?: number | null;
  runOrder?: number | null;
}

export interface RunOrderInput {
  runOrderDetails?: (RunOrderDetailsType | null)[] | null;
}

export interface SaveCarrierInput {
  id?: number | null;
  companyName?: string | null;
  type?: string | null;
  stateId?: number | null;
  extSystemIdentifier?: string | null;
  extSystemName?: string | null;
  name?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  zip?: string | null;
  city?: string | null;
  phoneNumber?: string | null;
  email?: string | null;
  isActive?: boolean | null;
  extSystemIdentifier2?: string | null;
  acronym?: string | null;
}

export interface SaveCrewInput {
  id?: number | null;
  crewNumber?: string | null;
  customerId?: number | null;
}

export interface SaveCustomerInput {
  id?: number | null;
  customerName?: string | null;
  description?: string | null;
  enabled?: boolean | null;
  extSystemIdentifier?: string | null;
  industryClassificationCode?: string | null;
  customerParentId?: number | null;
}

export interface SaveCustomerParentInput {
  id?: number | null;
  customerName?: string | null;
  enabled?: boolean | null;
  extSystemIdentifier?: string | null;
}

export interface SaveDriverInput {
  id?: number | null;
  driverName?: string | null;
  cellPhone?: string | null;
  cdlNumber?: string | null;
  cdlExpiryDate?: string | null;
  kronosId?: string | null;
  isActive?: boolean | null;
  isAssigned?: boolean | null;
  isManual?: boolean | null;
  isAvailable?: boolean | null;
  isShiftStarted?: boolean | null;
  isLocked?: boolean | null;
  driverCompanyId?: number | null;
  extSystemName?: string | null;
  extSystemIdentifier?: string | null;
  activeInactiveDate?: string | null;
  inactiveReason?: string | null;
  reactivationDate?: string | null;
  regionIds?: string | null;
  districtIds?: string | null;
  extSystemIdentifier3?: string | null;
}

export interface SaveLofaInput {
  id?: number | null;
  lofaName?: string | null;
  addressStreet?: string | null;
  city?: string | null;
  stateId?: number | null;
  utm?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  zip?: string | null;
  phoneNumber?: string | null;
  jdeNumber?: string | null;
  directions?: string | null;
  description?: string | null;
  geoFenceType?: string | null;
  geoFenceRadius?: number | null;
  entryKioskPolygon?: (LatLng | null)[] | null;
  polygonCoordinates?: (LatLng | null)[] | null;
  entryKioskPolygonCoordinates?: (LatLng | null)[] | null;
  districtId?: number | null;
  regionId?: number | null;
  kioskGeoFenceRadius?: number | null;
}

export interface SaveTonnageInput {
  fromDate: string;
  toDate: string;
  tonnageDetails?: (tonnageDetails | null)[] | null;
}

export interface SaveUserInput {
  id?: number | null;
  name?: string | null;
  emailAddress?: string | null;
  roleId?: number | null;
  isActive?: boolean | null;
  regionIds?: string | null;
  districtIds?: string | null;
}

export interface SaveYardInput {
  id?: number | null;
  yardName?: string | null;
  yardTypeId?: number | null;
  longitude?: number | null;
  latitude?: number | null;
  addressStreet?: string | null;
  city?: string | null;
  stateId?: number | null;
  utm?: string | null;
  zip?: string | null;
  phoneNumber?: string | null;
  directions?: string | null;
  description?: string | null;
  geoFenceType?: string | null;
  geoFenceRadius?: number | null;
  yardPolygonCoordinates?: (LatLng | null)[] | null;
  districtId?: number | null;
  regionId?: number | null;
}

export interface SendEmailInput {
  stageSheetId?: number | null;
  jobName?: string | null;
  wellHeadDetails?: string | null;
  fileName?: string | null;
  jobId?: number | null;
  emailrecipients?: string | null;
}

export interface SendMessageToConversationInput {
  conversationId?: string | null;
  conversationName?: string | null;
  driverIdList?: (number | null)[] | null;
  isFromDriver?: boolean | null;
  isGrupal?: boolean | null;
  message?: MessagesInput | null;
  regionIdList?: (number | null)[] | null;
  userId?: number | null;
  driverId?: number | null;
}

export interface StageDetailsForAddStages {
  wellHead?: string | null;
  stageNum?: number | null;
  stageSheetDescrip?: string | null;
}

export interface StageDetailsForEditStages {
  stageId?: number | null;
  wellHead?: string | null;
  stageNum?: number | null;
  stageSheetId?: number | null;
  stageSheetDescrip?: string | null;
}

export interface StageSheetDetailsToRevert {
  stageSheetBoxId?: number | null;
  loadId?: number | null;
  weight?: number | null;
  weightRemaining?: number | null;
}

export interface StageSheetDetailsType {
  stageSheetBoxId?: number | null;
  station?: number | null;
  weightRemaining?: number | null;
}

export interface StandByDriverInput {
  jobId?: number | null;
  carrierIds?: (number | null)[] | null;
}

export interface StartStagesInput {
  stageIds?: (number | null)[] | null;
  jobId?: number | null;
  fromStageSheet?: boolean | null;
}

export interface StopJobLogInput {
  jobLogId?: number | null;
}

export interface TmsDuplicateCheckInput {
  tmsIds?: (number | null)[] | null;
}

export interface UpdateActiveForJobSummaryInput {
  jobSummaryId?: number | null;
  isActive?: boolean | null;
}

export interface UpdateAssetPlansInput {
  jobId?: number | null;
  equipmentInfo?: (EquipmentInfoType | null)[] | null;
}

export interface UpdateBoxInLoadInput {
  loadId?: number | null;
  boxId?: number | null;
  boxNumber?: string | null;
}

export interface UpdateBoxInput {
  command?: string | null;
  stageSheetBoxId?: number | null;
  weightRemaining?: number | null;
}

export interface UpdateBoxWeightInput {
  boxId?: number | null;
  loadId?: number | null;
  inventoryWeight?: number | null;
  oldInventoryWeight?: number | null;
  stageSheetBoxId?: number | null;
}

export interface UpdateInventoryWeightInput {
  boxId?: number | null;
  loadId?: number | null;
  inventoryWeight?: number | null;
}

export interface UploadImageToJobInput {
  jobId?: number | null;
  uploadImageToJob?: UploadImageToJobInputDetails | null;
}

export interface UploadImageToJobInputDetails {
  name?: string | null;
  imageName?: string | null;
  imageData?: string | null;
}

export interface UploadImageToLoadInput {
  loadId?: number | null;
  uploadImageToLoad?: UploadImageToLoadInputDetails | null;
}

export interface UploadImageToLoadInputDetails {
  name?: string | null;
  imageName?: string | null;
  imageData?: string | null;
  isDriver?: boolean | null;
}

export interface ValidateInventoryBoxInput {
  boxId?: number | null;
  loadId?: number | null;
}

export interface VosUploadImageInput {
  jobId?: number | null;
  year?: number | null;
  monthId?: number | null;
  weekId?: number | null;
  uploadImageToJob?: VosUploadImageInputDetails | null;
}

export interface VosUploadImageInputDetails {
  name?: string | null;
  imageName?: string | null;
  imageData?: string | null;
}

export interface WeightDetailsType {
  stageSheetProppantId?: number | null;
  totalWeight?: number | null;
}

export interface WellheadInput {
  proppants?: (ProppantInput | null)[] | null;
  stages?: number | null;
  stageTime?: number | null;
  wellName?: string | null;
}

export interface partialBox {
  stageSheetBoxId?: number | null;
  boxDesc?: number | null;
  proppantId?: number | null;
  stageSheetId?: number | null;
  splitWeight?: number | null;
}

export interface allocateBox {
  id: number;
  loadId: number;
  jobId: number;
  boxId: number;
  proppantId: number;
  boxDesc: string;
  allocationWeight: number;
  isBoxAllocated: boolean;
  isLoadAllocated: boolean;
}

export interface tonnageDetails {
  jobsummaryId: number;
  tonnage?: number | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
// Manually Added for belly box

export interface GetAllocationInventory_getAllocationInventory {
  __typename: "AllocationInventoryResponse";
  loadId: number | null;
  proppantColor: string | null;
  sandTicket: string | null;
  weightDelivered: number | null;
  weightRemaining: number | null;
  fillPerc: number | null;
  proppantId: number | null;
  proppantDesc: string | null;
  boxDesc: string | null;
  isLoadAllocated: boolean | null;
}
export interface GetAllocationInventory {
  getBoxes: GetAllocationInventory_getAllocationInventory | null;
}

export interface GetAllocationInventoryVariables {
  jobId?: number | null;
}

//SS-943
export interface GetAllocateLoadBoxes_getAllocateLoadBoxes {
  __typename: "AllocateLoadBoxResponse";
  boxId: number | null;
  boxDesc: string | null;
  semiAllocated: boolean | null;
  proppantId: number | null;
  proppantColor: string | null;
  currentProppantWeight: number | null;
  fillPerc: number | null;
}
export interface GetAllocateLoadBoxes {
  getAllocateLoadBoxes: (GetAllocateLoadBoxes_getAllocateLoadBoxes)[] | null;
}

export interface GetActiveQueueBoxes {
  getActiveQueueBoxes: (GetAllocateLoadBoxes_getAllocateLoadBoxes)[] | null;
}

export interface GetAllocateLoadBoxesVariables {
  jobId?: number | null;
}

// Added for getBellyLoadAllocaions
export interface GetBellyLoadAllocaions_getBellyLoadAllocaions {
  __typename: "AllocateBoxResponses";
  id: number | null;
  loadId: number | null;
  jobId: number | null;
  boxId: number | null;
  proppantId: number | null;
  boxDesc: string | null;
  allocationWeight: number | null;
  isBoxAllocated: boolean | null;
  isLoadAllocated: boolean | null;
  isInDanceFloor: boolean | null;
  weightRemaining: number | null;  
}
export interface GetBellyLoadAllocaions {
  getBellyLoadAllocaions: GetBellyLoadAllocaions_getBellyLoadAllocaions [] | null;
}

export interface GetBellyLoadAllocatedBoxes {
  getBellyLoadAllocatedBoxes: GetBellyLoadAllocaions_getBellyLoadAllocaions [] | null;
}

export interface GetAllocationInventoryVariables {
  jobId?: number | null;
}
